/* eslint-disable */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import portNotes from './i18n_portNotes';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    lng: 'ua',
    fallbackLng: 'ua',
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      ua: {
        translation: {
          forKwh: 'за',
          btns: {
            start: ' годин',
            startKwt: ' кВт*г',
            startFree: 'Спробувати безкоштовно',
            startFullCharge: 'Швидкий Старт',
            getAllStationsStatus: 'Показати всі станції',
            getNearestStationsStatus: 'Станції поруч',
          },
          historyEmpty: 'Історія зарядок відсутня',
          showPwaInstruction: 'Встановити додаток',
          installApp: 'Встановити додаток',
          installAppText: 'Додаток 220 не потребує вільного місця на вашому телефоні.',
          installAppTextSecond: 'Щоб встановити додаток, натисніть на інструкцію:',
          installAppTextThird: 'Після встановлення додатку 220, будь ласка, використовуйте QR-сканер тільки з додатку.',
          installAppAttention: 'Увага!',
          installAppButton: 'Встановити додаток',
          installAppQrSectionLabel: 'QR-коди для встановлення додатку',
          installAppQrIosTitle: 'iOS',
          installAppQrIosSubtitle: 'App Store',
          installAppQrIosAlt: 'QR-код для встановлення з App Store',
          installAppQrPlayTitle: 'Android',
          installAppQrPlaySubtitle: 'Play Market',
          installAppQrPlayAlt: 'QR-код для встановлення з Google Play',
          installAppQrAndroidTitle: 'Android',
          installAppQrAndroidSubtitle: 'Завантажити APK',
          installAppQrAndroidAlt: 'QR-код для завантаження APK',
          title: 'Заряди 220 кілометрів за ніч',
          station: 'ПОРТ # ',
          feedbacks: 'Відгуки',
          leaveFeedback: 'Залишити відгук',
          feedback: {
            leave: 'Залишити відгук',
            title: 'Залишити відгук',
            textLabel: 'Ваш відгук',
            textPlaceholder: 'Розкажіть про досвід на цій станції…',
            ratingLabel: 'Оцінка',
            maxKwLabel: 'Макс. потужність авто',
            maxKwHint: 'кВт',
            kwUnit: 'кВт',
            carPhotoLabel: 'Фото авто біля станції',
            choosePhoto: 'Обрати фото',
            required: "обов'язково",
            optional: 'за бажанням',
            photoRequiredNear: 'Ви поруч зі станцією — додайте фото авто.',
            removePhoto: 'Прибрати фото',
            locating: 'Визначаємо вашу локацію…',
            submit: 'Надіслати',
            successTitle: 'Дякуємо!',
            successBody: 'Ваш відгук надіслано.',
            askPromptTitle: 'Залишити відгук?',
            askPromptBody: 'Поділіться враженням про цю станцію.',
            askPromptLeave: 'Залишити відгук',
            askPromptClose: 'Закрити',
            askPromptDontAsk: 'Більше не питати 30 днів',
            listTitle: 'Відгуки',
            teamLabel: 'Відповідь команди 220',
            empty: 'Ще немає відгуків',
            compose: 'Написати відгук',
            avgAria: 'Середня оцінка {{rating}}',
            reviewsCount: '{{count}} відгуків',
            prev: 'Назад',
            next: 'Далі',
            pageOf: '{{page}} / {{pages}}',
            carPower: '{{kw}} кВт',
            errors: {
              rateLimited: 'Можна залишити не більше 2 відгуків на добу.',
              paymentRequired: 'Відгук можна залишити після успішної оплати на цій станції.',
              photoRequired: 'Додайте фото авто біля станції.',
              tooLarge: 'Файл завеликий. Спробуйте інше фото.',
              generic: 'Не вдалося надіслати відгук. Спробуйте ще раз.',
            },
          },
          serviceRequestForm: {
            title: 'Заявка на сервіс',
            problemTypesLabel: 'Тип проблеми',
            problemTypes: {
              port_not_working: 'Не працює зарядний порт',
              station_offline: 'Станція не відповідає/вимкнена',
              cable_damage: "Пошкодження кабелю/роз'єму",
              payment: 'Проблема з оплатою',
              other: 'Інше',
            },
            portLabel: 'Номер порту',
            cityLabel: 'Місто',
            cityPlaceholder: 'Місто станції',
            descriptionLabel: 'Опис проблеми',
            descriptionPlaceholder: 'Опишіть, що сталося…',
            descriptionHint: 'Вкажіть марку/модель/рік авто, тип розʼєму та перехідник, якщо є.',
            phoneLabel: 'Телефон',
            phonePlaceholder: '+380…',
            photosLabel: 'Обовʼязкові фото',
            photoSlots: {
              car_port: 'Фото порту авто / адаптера + VIN',
              car: 'Фото авто',
              station: 'Фото номера станції / помилки на екрані',
            },
            removePhoto: 'Прибрати фото',
            optional: 'за бажанням',
            submit: 'Надіслати',
            successTitle: 'Заявку надіслано',
            successBody: 'Ми звʼяжемося з вами найближчим часом.',
            listTitle: 'Заявки на сервіс',
            empty: 'Ще немає заявок',
            compose: 'Нова заявка',
            errors: {
              rateLimited: 'Можна надіслати не більше 2 заявок на сервіс на добу.',
              problemRequired: 'Оберіть тип проблеми.',
              portRequired: 'Вкажіть номер порту.',
              descriptionRequired: 'Опишіть проблему, щонайменше 5 символів.',
              phoneRequired: 'Вкажіть номер телефону.',
              invalidPhone: 'Перевірте номер телефону.',
              photoRequired: 'Додайте це фото.',
              tooLarge: 'Файли завеликі. Спробуйте інші фото.',
              photosRequired: 'Додайте фото авто.',
              generic: 'Не вдалося надіслати заявку. Спробуйте ще раз.',
            },
          },
          refundForm: {
            title: 'Повернення коштів',
            portLabel: 'Номер порту',
            portPlaceholder: 'ПОРТ # на станції або 220-km.com',
            fullNameLabel: "Повне ім'я",
            fullNamePlaceholder: 'Прізвище та імʼя',
            reasonLabel: 'Тип причини',
            problemTypesLabel: 'Оберіть тип проблеми, з якою ви зіткнулися (можна вибрати декілька)',
            problemTypesPlaceholder: 'Оберіть тип проблеми',
            problemTypes: {
              port_not_working: 'Не працює зарядний порт',
              station_offline: 'Станція не відповідає/вимкнена',
              cable_damage: "Пошкодження кабелю/роз'єму",
              payment: 'Проблема з оплатою',
              other: "Інше (опишіть у полі 'Опис причини')",
            },
            phoneLabel: 'Номер телефону',
            phonePlaceholder: '+380…',
            descriptionLabel: 'Опис причини повернення',
            descriptionPlaceholder: 'Опишіть ситуацію…',
            descriptionHint:
              'При неуспішній зарядці вкажіть марку, модель і рік авто, тип конектора та перехідник (з кнопкою чи без для Tesla).',
            cardLabel: 'Номер картки для повернення',
            cardPlaceholder: '16 цифр',
            amountLabel: 'Сума повернення (грн)',
            amountPlaceholder: '0.00',
            contactedLabel: 'Чи звертались у підтримку 220 телефоном?',
            yes: 'Так',
            no: 'Ні',
            ratingLabel: 'Оцінка процесу зарядки',
            photosLabel: 'Обовʼязкові фото',
            photoSlots: {
              receipt: 'Банківський чек оплати',
              car: 'Фото авто / порту / помилки на дисплеї',
            },
            removePhoto: 'Прибрати фото',
            optional: 'за бажанням',
            submit: 'Надіслати заявку',
            successTitle: 'Заявку надіслано',
            successBody: 'Ми перевіримо платіж і повернемо кошти на картку.',
            manualHint: 'Новий телефон або немає сесії в історії — заповніть усі поля нижче.',
            termsSummary: 'Повернення на картку регулюється <termsLink>публічним договором (п. 7.3–7.4)</termsLink>.',
            terms73:
              'Заявку розглядає Агрегатор. Строк розгляду — до 60 робочих днів залежно від банку Користувача. Агрегатор намагається опрацювати звернення швидше. Якщо повернуті кошти вже були зараховані Виконавцю, Агрегатор має право утримати цю суму з подальших розрахунків із Виконавцем.',
            terms74: 'У заявці вкажіть телефон і причину. Сесія привʼязується автоматично за оплатою (invoice).',
            recoverAlternative:
              'Швидша альтернатива: відновіть віртуальний баланс за квитанцією — кошти можна одразу використати на наступну зарядку.',
            noSessionBody: 'Немає сесії для повернення. Напишіть у підтримку номер порту та квитанцію з банку.',
            button: 'Повернення',
            errors: {
              incomplete: 'Заповніть обовʼязкові поля',
              portRequired: 'Вкажіть номер порту',
              nameRequired: "Вкажіть повне ім'я",
              phoneRequired: 'Вкажіть телефон',
              phoneInvalid: 'Перевірте номер телефону',
              reasonRequired: 'Оберіть тип проблеми',
              descriptionRequired: 'Опишіть причину (мін. 10 символів)',
              cardRequired: 'Вкажіть номер картки (13–19 цифр)',
              amountRequired: 'Вкажіть суму в грн',
              contactedRequired: 'Вкажіть, чи звертались у підтримку',
              ratingRequired: 'Оцініть процес зарядки (1–5)',
              receiptPhotoRequired: 'Додайте банківський чек',
              carPhotoRequired: 'Додайте фото авто / порту / помилки',
              rateLimited: 'Можна надіслати не більше 2 заявок на повернення на добу.',
              invalidPhone: 'Перевірте номер телефону.',
              duplicate: 'Заявку за цю оплату вже надіслано.',
              tooLarge: 'Файл завеликий. Спробуйте інше фото.',
              generic: 'Не вдалося надіслати заявку. Спробуйте ще раз.',
            },
          },
          chargeLink: 'Зарядка',
          landingLink: 'Список станцій',
          landingLinkMap: 'Мапа станцій',
          contacts: "Зв'язатися з нами",
          buyUps: 'Купити ДБЖ',
          chooseVolume: 'Обрати',
          history: 'Історія зарядок',
          offer: 'Оферта',
          terms: {
            tabs: {
              driver: 'Для водіїв',
              stationOwner: 'Для власників станцій',
            },
            stationOwnerTitle: 'ПУБЛІЧНА ОФЕРТА\nДЛЯ ВЛАСНИКІВ ЗАРЯДНИХ СТАНЦІЙ В МЕРЕЖІ 220-km.com',
            stationOwnerIntro:
              'Цей документ визначає умови співпраці між Замовником (власником станції) та ФОП Павловим Максимом Валерійовичем щодо доступу до API 220-km.com під Банк.',
          },
          b2bContract: {
            tariffsLinkIntro: 'Детальний опис тарифів та можливостей можна знайти на',
            tariffsLinkLabel: 'сторінці 220-km.com/b2b',
          },
          wt: 'кВт*г',
          powerWt: ' кВт',
          maxPower: 'видає до:',
          maxPowerSticker: 'max {{kw}} kW',
          maxPowerStickerAria: 'Максимальна потужність {{kw}} кВт',
          maxPowerStickerRangeAria: 'Потужність {{minKw}}–{{maxKw}} кВт',
          portPriceStickerAria: 'Тариф {{price}} {{unit}} за кВт·г',
          portPriceStickerScheduleAria: 'Тариф {{price}} {{unit}} за кВт·г, показати розклад динамічного тарифу',
          portPriceStickerUnit: 'грн',
          plugTypeNoCable: 'без кабелю',
          dynamicTariffScheduleTitle: 'Динамічний тариф',
          portCardOpenStartManyAria: 'Відкрити всі порти пристрою, порт {{stationNumber}}',

          energy: 'кВт',
          energyKwh: ' кВт*г',
          balance: 'Баланс:',
          balanceNe: 'не',
          balanceWord: 'баланс:',
          energyCard: {
            label: 'energy card',
            kwhForPorts: 'кВт⋅г для зарядки на портах',
            uahForPorts: 'грн для зарядки на портах',
            chargeWithEc: 'Зарядити з Паливної Карти',
            validUntil: 'дійсна до',
            brandedName: 'Паливна картка на {{kwh}} kWh від 220-km.com',
            brandedNameUah: 'Паливна картка на {{uah}} грн від 220-km.com',
            cardId: 'ID картки',
            archived: 'Архівні картки',
            usedKwh: 'використано',
            leftKwh: 'залишилось',
            usedLeftLabel: '{{used}} / {{left}} кВт⋅г',
            usedLeftLabelUah: '{{used}} / {{left}} грн',
            chargingOnPort: 'зарядка на порту #{{port}}',
            clickPortForDetails: 'Натисніть на номер порту, щоб відкрити деталі',
            remainingUahHint: 'залишок {{uah}} грн',
          },
          currency: ' грн',
          portraitOnlyMessage: 'Поверніть пристрій вертикально',
          portraitOnlyHint: 'Додаток працює лише в портретному режимі',
          payedForKwh: 'Оплачено',
          spent: 'Витрачено',
          v: 'В',
          km: ' км',
          approximately: 'приблизно',
          chargedCongrats: 'Вітаємо!',
          chargedkWt: 'Заряджено: ',
          startNew: 'Хочу ще раз',
          stationStoppedCharging: 'Станція зупинила зарядку: {{detail}}',
          power: 'Потужність',
          powerExceededError: 'Будь ласка, зменшіть потужність і спробуйте ще раз:',
          onlineStatus: 'Офлайн',
          powerKm: 'км/год',
          charging: 'Заряджено',
          openPowerHistoryChart: 'Відкрити графік потужності',
          powerCurveSessionOnly: 'Графік потужності доступний лише для вашої сесії',
          voltage: 'Вольтаж',
          chargingSpeed: 'Швидкість заряду',
          solar: 'Сонце',
          bess: 'УЗЕ',
          bessReserveSource: 'Резервне живлення',
          stationAdditionalSourceBess: 'Ця станція має резервне живлення',
          batteryDischarge: 'Акумулятор',
          batteryCharging: 'заряджається',
          openEmsInverterLinkAria: 'Відкрити Open EMS для інвертора {{kwh}} кВт·г',
          renewable: 'зелена енергія',
          batterySocPct: 'SoC {{pct}}%',
          solarInsolationTomorrowLine: 'Завтра {{pct}}%',
          solarInsolationToday: 'Сьогодні',
          solarInsolationTomorrow: 'Завтра',
          solarInsolationForecast: 'Сонце сьогодні та завтра',
          solarInsolationDayGraphAria: 'Погодинний прогноз інсоляції на сьогодні для локації порту',
          solarInsolationTomorrowGraphAria: 'Погодинний прогноз інсоляції на завтра для локації порту',

          allStationsStatusUnavailable: 'Наразі не доступно',
          getBloodyLitersSaved: 'Реінкарновано',
          bloodyLitersLink: 'https://youtu.be/T0wK0VPy-V0?si=c9daReLH709PYE9q&t=83',
          noNearestStations: 'Поряд з вами станцій не виявлено',
          showing: 'Показано',
          of: 'з',
          stations: 'станцій',
          performanceMode: 'Режим продуктивності',
          fallbackMode: 'режим відновлення',
          loadingMore: 'Завантаження наступних',
          scrollToLoadMore: 'Прокрутіть для завантаження',
          loadMoreStations: 'Завантажити більше станцій',
          getDirection: 'Отримати маршрут',
          route: 'Маршрут',
          outageSchedule: {
            button: 'Графік відключень',
            title: 'Графік відключень',
            loading: 'Запитуємо графік…',
            group: 'Група {{group}}',
            today: 'Сьогодні',
            tomorrow: 'Завтра',
            noOutages: 'Планових відключень немає',
            waiting: 'Графік ще не опубліковано',
            emergency: 'Екстрені відключення',
            updated: 'Оновлено {{time}}',
            allGroups: 'Однаковий для всіх груп',
            queuesHint: 'Вулицю не розпізнано. Оберіть групу:',
            chooseGroup: 'Оберіть групу:',
            anotherGroup: 'Інша група',
            unsupported: 'Для цієї області графіка немає.',
            groupUnknown: 'Графік публікується за чергою. За GPS чергу визначити не можна.',
            notFound: 'Не вдалося знайти будинок за координатами порту.',
            error: 'Не вдалося отримати графік. Спробуйте ще раз.',
          },
          photo: 'Опис локації',
          distanceKm: ' км',
          distanceM: 'м',
          locationError: 'Увімкніть доступ до місцезнаходження в налаштуваннях браузера.',
          mapFarGpsAirAlert: 'Повітряна тривога у вашому регіоні, будь ласка, знайдіть найближче укриття.',
          mapFarGpsAirAlertDismiss: 'Зрозуміло',
          toHomePage: 'Станції поруч',
          allStations80Plus: 'Усі швидкі станції',
          allStationsEvboost: 'Усі станції',
          recoverBalance: 'Відновити баланс',
          recoverBalanceAutomatically: 'Відновити баланс',
          recoverBalanceUploadHint:
            'Завантажте скріншот оплати з банку (монобанк, ПриватБанк тощо). Суму в гривнях буде розпізнано автоматично.',
          recoverBalanceSelectFile: 'Завантажити скріншот',
          recoverBalanceSubmit: 'Відновити',
          recoverBalanceManualFallback: 'Оформити заявку вручну',
          recoverBalanceError: {
            PARSE_FAILED: 'Не вдалося розпізнати суму з фото. Спробуйте чіткіший скріншот.',
            ORDER_NOT_FOUND: 'Замовлення з такою сумою не знайдено. Перевірте квитанцію.',
            ALREADY_RECOVERED: 'Не можна відновити одну й ту саму квитанцію багато разів.',
            NO_IMAGE: 'Оберіть скріншот квитанції.',
            RATE_LIMITED: 'Забагато спроб. Спробуйте завтра.',
            NATIVE_APP_REQUIRED: 'Відновлення балансу доступне лише в додатку 220.',
            UNKNOWN: 'Помилка. Спробуйте пізніше.',
          },
          serviceRequest: 'Заявка на сервіс',
          notifyWhenOnline: "Повідомити, коли з'явиться",
          notifyWhenFinish: 'Повідомити про завершення',
          freshPorts: 'Є Світло',
          online: 'Онлайн',
          offline: 'Офлайн',
          seconds: 'сек',
          minutes: 'хв',
          hours: 'год',
          days: 'дн',
          allCars: 'Авто з Китаю',
          china: 'Авто з Китаю',
          allPorts: 'Всі Порти',
          onlyFast: 'Швидкі Зарядки',
          filter80Kw: '+ Роумінг',
          filter160Kw: '160+ kW',
          filterFast: 'Швидкі',
          filterSlow: 'Повільні',
          filterChina: 'Китайські порти',
          filterNacs: 'NACS',
          filterCheapest: 'Найдешевші',
          filterEuropean: 'Європа та Америка',
          filterOnline: 'Є Світло',
          єСвітло: 'єСвітло',
          mapPortSearchPlaceholder: '№ порту',
          mapPortSearchNoResults: 'Порт не знайдено',
          mapPortSearchLoading: 'Пошук…',
          mapPortSearchRoute: 'Маршрут',
          openMapsTitle: 'Відкрити маршрут',
          openMapsInWaze: 'Навігація в Waze',
          openMapsInGoogle: 'Навігація в Google',
          openMapsInEvua: 'Відкрити в EV UA',
          openMapsEvuaDetailsLoading: 'Завантаження деталей…',
          openMapsEvuaDetailsEmpty: 'Деталі станції недоступні',
          openMapsEvuaOperator: 'Оператор',
          openMapsEvuaProvider: 'Провайдер',
          openMapsEvuaVendor: 'Виробник',
          openMapsEvuaConnectors: "Роз'єми",
          openMapsEvuaPrice: 'Тариф',
          openMapsEvuaPriceValue: '{{price}} грн/кВт·г',
          openMapsEvuaPower: 'Потужність',
          openMapsEvuaPowerValue: '{{power}} кВт',
          openMapsEvuaStationId: 'ID',
          openMapsEvuaCoords: 'Координати',
          stationListSearchPlaceholder: 'Пошук',
          stationListSearchNoResults: 'Станцій за запитом не знайдено',
          listOpenEmsEvPowerTitle: 'Зарядка EV',
          listOpenEmsEvPowerTariff: '{{value}} грн/кВт·г',
          listOpenEmsEvPowerSessions: '{{count}} активних сесій',
          listOpenEmsEvPowerAria: 'Загальна потужність зарядки EV з Open EMS',
          listOpenEmsGreenEnergyAria: 'Частка зеленої енергії мережі зарядки з Open EMS',
          listOpenEmsBannerAria: 'Зелена енергія, сумарна потужність і активні сесії зарядки з Open EMS',
          startPageShareBtn: 'Поділитися портом',
          startPageShareTitle: 'ПОРТ #{{port}}',
          startPageShareText: 'Зарядна станція 220-km — порт №{{port}}',
          startPageShareQrAlt: 'QR-код посилання на порт',
          startPageShareStickerPreviewAlt: 'Попередній перегляд PNG-стікера порту №{{port}}',
          startPageSharePortTypeWithPower: 'Тип розʼєму: {{type}} · {{kw}} kW',
          startPageSharePortTypeOnly: 'Тип розʼєму: {{type}}',
          startPageSharePortPowerOnly: 'Потужність: {{kw}} kW',
          startPageShareStickerPortLabel: 'ПОРТ # ',
          startPageShareStickerDownload: 'Завантажити PNG-стікер',
          startPageShareStickerDownloading: 'Готуємо PNG…',
          startPageShareStickerError: 'Не вдалося створити PNG-стікер',
          startPageSharePrintOrder: 'Замовити друк: @kpiprint1',

          login: 'Увійти з Google',
          loginTitle: 'Вітаємо',
          loginText: 'Увійдіть, щоб продовжити',

          logout: 'Вийти',

          userInfoName: 'Уввійшли як',

          slider: {
            kWhFor: 'кВт*г',
            aboutKm: 'біля',
          },
          historyPage: {
            station: 'ПОРТ #',
            openPort: 'Відкрити ПОРТ #',
            amountS: 'Тривалість',
            avgPower: 'Сер. потужність',
            price: 'Оплачено',
            spendEnergy: 'Витречено енергії',
            finished: 'Закінчено',
            refund: 'Повернуто',
            bankRefund: 'Повернено на картку',
            bankRefundStatus: 'Повернення на картку',
            bankRefundSuccess: 'Повернено',
            balance: 'Баланс',
            state: 'Статус',
            timeHours: 'г',
            timeMinutes: 'хв',
            receipt: 'Отримати чек',
            loading: 'Завантаження...',
            receiptError: 'Помилка завантаження чека',
            clientUiId: 'ID клієнта',
            copyClientId: 'Копіювати ID клієнта',
            copiedToClipboard: 'Скопійовано в буфер обміну!',
            clientOs: 'Операційна система',
            clientIdQrTitle: 'Хочете поділитися балансом та історією з другом чи родиною?',
            clientIdQrSubtitle: 'Просто відскануйте QR з телефону друга!',
            clientIdQrAlt: 'QR код клієнта',
            toggleClientIdQr: 'Показати QR клієнта',
            createFamily: 'Надати доступ до балансу',
            scanClientIdQr: 'Сканувати QR-код друга',
            loadClientIdQrFromPhoto: 'Імпортувати фото QR-коду',
            loadClientIdQrFromPhotoError: 'Не вдалося розпізнати QR на фото. Спробуйте інший скріншот.',
            powerCurve: 'Графік потужності',
            power: 'Потужність',
            voltage: 'Напруга',
            soc: 'SOC',
            summaryTimeSpent: 'Витрачений час',
            summarySocLabel: 'SoC',
            summarySocLine: 'старт {{started}}% + {{charged}}% = {{total}}%',
            summaryAvgPower: 'Сер. потужність',
            summaryPeakPower: 'Пікова потужність',
            min: 'Мін',
            max: 'Макс',
            avg: 'Сер',
            noPowerData: 'Немає даних кривої',
            powerCurvePending: 'Графік з’явиться після 10 хв зарядки',
            revenueChartLast6Months: 'Останні 6 місяців',
            revenueChartPrevious6Months: 'Попередні 6 місяців',
            revenueChartMonthAxis: 'Місяць',
            revenueChartTooltipCharged: 'Заряджено',
            revenueChartTooltipSpent: 'Витрачено',
            revenueChartTooltipAvgPower: 'Сер. потужність',
            revenueChartTotalCharged: 'Заряджено',
            revenueChartLitersUnit: 'Л A-95',
            revenueChartSavedCo2: 'CO₂',
            revenueChartCo2Unit: 'т',
            revenueChartSummaryAria: 'Підсумки',
            loadOlderSessions: 'Старіші сесії',
          },
          kW: 'кВт',

          stopButton: 'Стоп',
          stopChargingConfirm: {
            title: 'Зупинити зарядку?',
            message: 'Зарядка буде завершена. Продовжити?',
            cancel: 'Скасувати',
            error: 'Не вдалося зупинити зарядку. Спробуйте ще раз.',
          },
          startButton: 'Почати',
          refresh: 'Оновити',

          qrScanner: {
            nameButton: 'Сканувати QR-код',
            backButton: 'Назад',
            refresh: 'Оновити',
            cameraPermissionAlert: 'Будь ласка, дозвольте доступ до камери та оновить сторінку',
            cameraUnavailable:
              'Камера доступна лише через HTTPS. Відкрийте https://localhost:3000/scanner або вставте текст QR нижче.',
            pasteClientIdHint: 'Вставте QR клієнта (220km-client-id:...)',
            importClientIdButton: 'Імпортувати',
            scanHint: 'Наведіть QR-код у центральну рамку',
            scanning: 'Сканування',
            invalidTokaUrl: 'Невірне посилання Toka',
            tokaNotFound: 'Порти 220 для цієї станції Toka не знайдено',
            tokaLookupError: 'Не вдалося знайти порти 220 для Toka',
            tokaErrorDetail: 'Порти 220 для станції Toka #{{tokaNumber}} не знайдено. Посилання: {{url}}',
            tokaInvalidUrlDetail: 'Невірне посилання Toka: {{url}}',
            clientIdInvalid: 'QR клієнта не розпізнано',
            energyCardInvalid: 'QR Energy Card не розпізнано',
            energyCardActivateError: 'Не вдалося активувати Energy Card',
            energyCardAlreadyScanned: 'Паливну картку вже відскановано',
            energyCardWebInstallPopup: 'Будь ласка, встановіть нативний додаток і скануйте з нього',
            loadFromPhoto: 'Імпортувати фото QR-коду',
            loadingFromPhoto: 'Читання QR…',
            loadFromPhotoError: 'Не вдалося розпізнати QR на фото. Спробуйте інший скріншот.',
          },

          errorStart: {
            portConnectedQuestion: 'Саме ПОРТ # {{portNumber}} підключено до авто?',
            ifSoPleaseDo: 'Будь ласка,',
            alertMessage: 'дістаньте конектор з машини та підключіть знову',
          },

          inServiceWarning: 'Цей порт може працювати некоректно',
          portInServiceSince: 'Порт на обслуговуванні з {{date}}',
          portInService: 'Порт на обслуговуванні',
          portInRepairForDays: 'в ремонті {{daysText}}',

          error: 'Помилка',
          errorDevHeader: 'Помилка серверу',
          errorDevBody: 'Ми вже вирішуємо проблему і скоро повернемось :)',
          errorOfflineHeader: 'ПОРТ # <1>{{stationNumber}}</1> офлайн :(',
          errorOfflineBody: 'Немає світла або не в мережі',
          errorOfflineDcEmergencyHint: 'Будь ласка, перевірте чи відтиснута червона аварійна кнопка на станції',
          errorPayHeader: 'Оплата недоступна!',
          errorPayBody: 'Ми вже вирішуємо проблему і скоро повернемось :)',
          paymentNotConfigured: 'Оплата не налаштована',
          errorStartFailedHeader: 'Ой, халепа :( Витягніть коннектор та вставте ще раз.',
          errorStartFailedBody: '',
          errorFingerPrintUndefindHeader: 'Виявлений блокувальник реклами',
          errorFingerPrintUndefindBody: 'Будь ласка, вимкніть і спробуйте ще раз',
          errorFingerPrintUnavailableHeader: 'Безкоштовна зарядка вже використана',
          errorFingerPrintUnavailableBody: 'Здійсніть будь ласка оплату :)',

          stationOffline: 'Не в мережі',
          noInternetConnection: 'Немає підключення до інтернету',
          serverConnectionChecking: 'Перевірка зʼєднання з сервером...',
          serverConnectionError: 'Немає зʼєднання з сервером, спробуйте зайти з мобільного інтернету',
          ipBlockedError: {
            title: 'Доступ заблоковано',
            message: 'Ваша IP-адреса {{ip}} заблокована',
          },
          offlineForDays: '{{days}} днів',

          costPerHour: ' грн за годину',
          costPerKwt: ' грн за кВт',
          costPerKwtAlt: ' грн за кВт',
          costPerKwtH: ' грн за кВт*г',

          roamingWithToka: 'роумінг з toka',

          readyForUse: 'Вільний!',
          listPortConnectedToCar: 'Підключено до авто',
          listPortAvailable: 'Доступний',
          ready: 'ГОТОВИЙ',
          connected: 'ПІДКЛЮЧЕНО',
          inProgress: 'ЗАРЯДКА',
          selectPort: 'Please select PORT',
          noPortsFound: 'Порти не знайдені',
          noPortsSpecified: 'Будь ласка, вкажіть порти в URL',
          goToPort: 'Перейти до ПОРТУ',
          startManyRegionUnknown: 'Україна',
          startManyRegionTapForStatus: 'Показати статус: {{status}}',
          startManySheetExpandMap: 'Показати карту',
          startManySheetCollapseMap: 'Сховати карту',
          startManySheetHintUp: 'Проведіть вгору — карта',
          startManySheetHintDown: 'Проведіть вниз — порти',
          startManyShareBtn: 'Поділитися станцією',
          startManyShareTitle: 'Станція 220-km.com',
          startManyShareText: 'Зарядна станція 220-km.com — порти {{ports}}',
          startManyShareQrAlt: 'QR-код посилання на станцію',
          startManyMaxPower: 'Макс. потужність',
          startManyPricePerKwh: '{{price}} грн за 1 кВт·г',

          calibration: 'Відкалібруйте результат!',
          enterYourKm: 'Будь ласка, введіть заряджені кілометри',
          sendKm: 'Калібрувати',
          calibratedKm: 'Ваш результат відкалібровано',
          btnRepeat: 'Повторити',

          featureInProgress: 'Чекайте в наступному оновленні :)',

          back: 'Повернутись',
          close: 'Закрити',
          photoSource: {
            title: 'Скріншот QR лежить у бібліотеці фото',
            library: 'Завантажити з бібліотеки',
            cancel: 'Скасувати',
          },
          delayedStart: 'Зарядка почнеться о <1>{{openFrom}}</1>',
          beforePayInfoKwh: 'Оплатити зарядну сесію',
          beforePayInfo: "Рекомендуємо обирати мінімальний об'єм, щоб НЕ накопичувати зайві баланси.",
          beforeStartInfo: 'Почати зарядну сесію',
          cancelDelayedStart: 'Відмінити',
          delayedInfo: 'Працює з <1>{{openFrom}}</1> до <1>{{closedFrom}}</1>',
          leftBeforeStart: 'До старту залишилося:',
          startAt: 'Почнеться о <1>{{openFrom}}</1>',
          stationCardInfo: 'з <1>{{openFrom}}</1> до <1>{{closedFrom}}</1>',

          offerTitle: 'ПУБЛІЧНА ОФЕРТА',
          callUs: 'Зателефонувати',
          contactUs: "Зв'язатися з нами",
          instagram: 'Інстаграм',
          telegram: 'Телеграм Бот',
          whatsApp: 'Ватсап',
          tapCall: 'Зателефонувати',
          tapChatBot: 'Отримати допомогу через чат',
          telHlib: 'Гліб',
          telMax: 'Макс',
          notFound: 'Сторінка не знайдена',
          btnPay: 'Оплатити',
          btnPayFor: 'Старт',
          guestPay: {
            title: 'Оплатити в гостьовому режимі?',
            yes: 'Так',
          },
          driverTermsAccept: {
            label: 'Я погоджуюсь з <termsLink>умовами договору</termsLink>',
            popupText: 'Щоб продовжити, погодьтесь з <termsLink>умовами договору</termsLink>',
            agree: 'Погоджуюсь',
          },
          overload: {
            waitForLink: 'Зачекайте секунду',
            gettingLink: 'Отримуємо посилання для оплати',
            successChecked: 'Вийшло',
            letsCharge: 'Погнали заряджати',
            checking: 'перевіряємо навантаження',
            overloadDetected: 'Виявлено перевантаження',
            slowdown: 'Будь ласка, зменшіть напругу до',
            repeat: 'і спробуйте ще раз',
          },
          footer: {
            part1: 'Всі права захищені',
            part2: 'Розроблено',
            part3: 'з ♥ до електромобілів',
          },

          b2bHeader: 'Для бізнесу',
          b2bHeaderNew: 'Для бізнесу (beta)',
          microgridHeader: 'Енергонезалежність',
          b2bWelcomeTitle: 'B2B для власників зарядних станцій',
          b2bSeoMetaDescription:
            'B2B 220-km.com: статистика зарядних станцій, тарифи, РДН/ВДР (OREE), діаграма потоку енергії EMS + VPP. Open EMS — система розумного керування енергією для мікромереж (СЕС, BESS, EV): автоматизоване сценарне керування заряд/розряд, арбітраж на РДН та ВДР, ML-прогноз генерації та цін, Modbus/MQTT/OPC UA, острівний режим. https://github.com/220-organization/open-ems. Дані 220-km.com проаналізовані в статті ІЕД НАН України про динамічне ціноутворення на ЕЗС та балансування ОЕС (порт 2005, Південноукраїнськ, 2025).',
          b2bSeoMetaKeywords:
            'система розумного керування енергією, мікромережа EMS, BESS моніторинг, моніторинг СЕС, ML-прогноз сонячної генерації, ML-прогноз цін РДН, арбітраж РДН ВДР, активний споживач, острівний режим, Modbus MQTT OPC UA, Open EMS, EMS Ukraine, VPP, РДН, ВДР, OREE, енергоменеджмент, зарядні станції B2B, 220-km, Deye, Huawei FusionSolar, smart charging, DER, B2B API, ІЕД НАН України, балансування ОЕС, дешева зарядка, найдешевша зарядка, де зарядитись при вимкненні світла',
          b2bFlowGraphSeoMetaDescription:
            'Діаграма потоку енергії 220-km.com: smart EMS для мікромереж — СЕС, BESS, зарядка EV, арбітраж РДН/ВДР, ML-прогноз. Open EMS (open-source): https://github.com/220-organization/open-ems',
          b2bMarketplaceSeoTitle: 'Де встановити зарядну станцію — маркетплейс локацій',
          b2bMarketplaceSeoMetaDescription:
            'Маркетплейс локацій 220-km.com для власників зарядних станцій: знайдіть, де встановити зарядну станцію — карта попиту на зарядку по Україні, готові локації під зарядні хаби з договором з обленерго. Альтернатива мережам OKKO, AYONIT, Ionity: оберіть точку, домовтесь із власником ділянки та запустіть швидку EV-зарядку.',
          b2bMarketplaceSeoMetaKeywords:
            'де встановити зарядну станцію, зарядні хаби, маркетплейс локацій для зарядних станцій, локація під зарядну станцію, оренда місця під ЕЗС, карта попиту на зарядку EV, OKKO зарядні станції, AYONIT, айоніт, Ionity, договір з обленерго, швидка зарядка EV, інвестиції в зарядні станції, бізнес на зарядних станціях, 220-km',
          b2bWelcomeText: 'Увійдіть в кабінет 220-km.com для перегляду статистики та керування станціями.',
          b2bEvDriversCountLabel: 'Кількість користувачів',
          b2bEvDriversCountInMonth: ' в {{month}}',
          b2bMonthJan: 'січні',
          b2bMonthFeb: 'лютому',
          b2bMonthMar: 'березні',
          b2bMonthApr: 'квітні',
          b2bMonthMay: 'травні',
          b2bMonthJun: 'червні',
          b2bMonthJul: 'липні',
          b2bMonthAug: 'серпні',
          b2bMonthSep: 'вересні',
          b2bMonthOct: 'жовтні',
          b2bMonthNov: 'листопаді',
          b2bMonthDec: 'грудні',
          b2bEnterCabinetBtn: 'Увійти в кабінет',
          b2bTariffsLink: 'Тарифи та можливості',
          b2bStatsAvgRate7Days: 'Середній тариф за 7 днів (грн/кВт⋅год)',
          b2bStatsAvgRate30Days: 'Середній тариф за 30 днів (грн/кВт⋅год)',
          b2bStatsPerDay: 'За добу',
          b2bStatsPerMonth: 'За місяць',
          b2bStatsAvgRateForPeriod: 'Середній тариф за {{period}} (грн/кВт⋅год)',
          b2bStatsAvgRateLabel: 'Середній тариф в роумінговій мережі 220-km.com',
          b2bStatsAvgRateLabelFor: 'за',
          b2bStatsAvgRateValueWithUnit: '{{value}} грн/кВт⋅г',
          b2bStatsTrendVsDayBefore: 'до попереднього дня',
          b2bStatsTrendVsMonthBefore: 'до попереднього місяця',
          b2bMonthPickerThisMonth: 'Поточний місяць',
          b2bMonthPickerPrevYear: 'Попередній рік',
          b2bMonthPickerNextYear: 'Наступний рік',
          b2bOreePriceIndicesTitle: 'Індекси цін (OREE)',
          b2bOreePriceIndicesOpen: 'Відкрити на oree.com.ua',
          b2bOpenEmsMonthlyRatesTitle: 'Тариф',
          b2bOpenEmsMonthlyRatesSubtitle: 'Середній тариф для бізнесу з розподілом та ПДВ',
          b2bOpenEmsMonthlyRatesOpen: 'Відкрити Open EMS',
          b2bOpenEmsMonthlyRatesUnit: '/кВт*г',
          b2bOpenEmsMonthlyRatesVsPrev: 'в порівняні з {{month}}',
          b2bOpenEmsMonthlyRatesNoComparison: 'Без порівняння',
          b2bOpenEmsMonthlyRatesPending: '...',
          b2bDayKwhChartTitle: 'погодинні обсяги',
          b2bDayKwhChartMarketShare: 'Частка ринку України: ~ {{pct}}',
          b2bDayKwhChartDateLabel: 'Дата',
          b2bDatePickerToday: 'Сьогодні',
          b2bDatePickerPrevMonth: 'Попередній місяць',
          b2bDatePickerNextMonth: 'Наступний місяць',
          b2bDatePickerPrevDay: 'Попередній день',
          b2bDatePickerNextDay: 'Наступний день',
          b2bTomorrowChartGateTitle: 'Дані на завтра — лише після контакту',
          b2bTomorrowChartGateBody:
            'Детальний перегляд погодинного графіка на майбутній день доступний після консультації. Зв’яжіться з нами через кнопку нижче — обговоримо РДН.',
          b2bTomorrowChartGateClose: 'Закрити',
          b2bTomorrowChartGateBack: 'Назад',
          b2bDayKwhChartLoading: 'Завантаження…',
          b2bDayKwhChartNoData: 'Немає даних за обрану дату',
          b2bDayKwhChartRateLimited:
            'Перевищено ліміт запитів. Спробуйте пізніше (за добу дозволено обмежена кількість переглядів).',
          b2bDayKwhChartVolumeLabel: 'Обсяг, кВт·год',
          b2bDayKwhChartTariffAxisLabel: 'Тариф, грн/кВт·год',
          b2bDayKwhChartLegend220: 'Обсяг, кВт·год (220)',
          b2bDayKwhChartLegendToka: 'Обсяг, кВт·год (toka)',
          b2bDayKwhChartLegendTariff: 'Тариф, грн/кВт·год',
          b2bDayKwhChartLegendDam: 'РДН, грн/кВт·год',
          b2bMarketNameDam: 'DAM',
          b2bMarketNameRdn: 'РДН',
          b2bMarketTariffUnitUahPerKwh: 'грн/кВт·год',
          b2bDayKwhChartLegendMarketLine: '{{market}}, {{unit}}',
          b2bDayKwhChartTooltipPriceWithUnit: '{{value}} {{unit}}',
          b2bDayKwhChartTooltipHour: 'Година',
          b2bDayKwhChartTooltipVolume: 'Обсяг',
          b2bDayKwhChartTooltipTariff: 'Тариф',
          b2bDayKwhChartTooltipDam: 'РДН',
          b2bDayKwhChartSeriesEv: 'Зарядні',
          b2bDayKwhChartSeriesDam: 'РДН',
          b2bDayKwhChartSeriesMining: 'Майнінг',
          b2bNoStationsHeader: 'Ви ще не маєте станцій',
          b2bNoStationsBody: "Зв'яжіться з нами для замовлення",
          b2bStartBusinessHeader: 'Бажаєте отримувати пасивний дохід від заряджання електромобілів?',
          b2bStartBusinessText: 'Все дуже просто, будь ласка, заповніть форму і ми зареєструємо станцію для Вас:',
          b2bAddStationHint: 'Хочеш стати частиною мережі іновацій 220 ?\nТисни ⚡ Приєднатися до 220',
          b2bRealtimePowerLabel: 'Потужність зараз (МВт)',
          b2bRealtimePowerSessions: '{{count}} зарядж. сесій (IN_PROGRESS)',
          b2bRealtimePowerNoActive: 'Немає активної зарядки',
          b2bRegisterStationBtn: 'Зареєструвати станцію',
          b2bConnectTo220Btn: 'Приєднатися до 220',
          b2bProposeLocationBtn: 'Запропонувати локацію',
          b2bLookingForLocationBtn: 'Шукаю локацію',
          b2bTelegramConnectTo220Greeting: 'Доброго дня! Хочу підключитися до 220.',
          b2bTelegramGreeting: 'Я власник, пропоную оренду локації',
          b2bTelegramLookingForLocationGreeting: 'Я інвестор, шукаю локацію',
          b2bContactUsBtn: "Зв'язатися з нами",
          b2bLicenseLinkBtn: 'Про ліцензію на торгівлю\nелектроенергією',
          b2bConsultRdnBtn: 'Замовити консультацію по РДН',
          b2bGammaPresentationOpen: 'Відкрити презентацію на весь екран',
          b2bTelegramConsultRdnGreeting: 'Доброго дня! Хочу замовити консультацію по РДН.',
          b2bMessengerChoiceTitle: 'Залишити заявку',
          b2bLeadFormSubmit: 'Надіслати',
          b2bLeadFormNameLabel: "Ім'я",
          b2bLeadFormNamePlaceholder: "Введіть ім'я",
          b2bLeadFormPhoneLabel: 'Телефон',
          b2bLeadFormPhonePlaceholder: 'Введіть номер телефону',
          b2bLeadFormMessengerHint: 'Надішліть заявку через месенджер — ми передзвонимо.',
          b2bLeadFormPublishHint: 'Опублікуйте заявку на маркетплейсі локацій Вирій ЕМС.',
          b2bLeadFormMarketplaceHint: 'Або опублікуйте заявку без месенджера',
          b2bMessengerPublishMarketplace: 'Опублікувати на маркетплейсі Вирій ЕМС',
          b2bMessengerPublishMarketplaceSuccess: 'Заявку надіслано. Після модерації вона з’явиться на маркетплейсі.',
          b2bMessengerPublishMarketplaceError: 'Не вдалося опублікувати на маркетплейсі',
          b2bLeadFormKwLabel: 'Доступна потужність, кВт',
          b2bLeadFormRequired: "Обов'язкове поле",
          b2bLeadFormInvalidPhone: 'Вкажіть коректний номер телефону',
          b2bLeadFormLocationsRequired: 'Додайте хоча б одну локацію на карті',
          b2bLeadFormRegionLabel: 'Бажаний регіон',
          b2bLeadFormRegionRequired: 'Оберіть регіон на карті',
          b2bLeadFormRegionRadiusLabel: 'Радіус пошуку',
          b2bLeadFormRegionRadiusValue: '{{value}} км',
          b2bLeadFormRegionMapHint: 'Натисніть на мапу, щоб обрати центр пошуку, і задайте радіус навколо точки.',
          b2bLeadFormRegionMapAria: 'Карта для вибору регіону',
          b2bLeadFormMessagePreview: 'Попередній перегляд повідомлення',
          b2bLeadFormSubmitError: 'Заповніть усі обовʼязкові поля перед відправкою',
          b2bLeadFormSaveError: 'Не вдалося зберегти заявку. Спробуйте ще раз.',
          b2bLeadFormSentStatus: 'Заявку надіслано. Команда 220 зв’яжеться з вами.',
          b2bLeadFormRateLimit: 'Забагато заявок з цієї мережі. Спробуйте пізніше.',
          b2bLeadFormDistributionLabel: 'Договір з облэнерго',
          b2bLeadFormYes: 'Так',
          b2bLeadFormNo: 'Ні',
          b2bLeadFormLocationsLabel: 'Локації на карті',
          b2bLeadFormMapHint:
            'Натисніть на карту, щоб додати локацію. Можна обрати кілька точок. Кнопка «Моє місцезнаходження» лише центрує карту.',
          b2bLeadFormMapAria: 'Карта для вибору локацій',
          b2bLeadFormMapGeolocate: 'Моє місцезнаходження',
          b2bLeadFormMapLoading: 'Завантаження…',
          b2bLeadFormMapRemove: 'Видалити',
          b2bLeadFormParkingPhotosLabel: 'Фото парковки (необовʼязково)',
          b2bLeadFormConnectionPhotosLabel: 'Фото точки приєднання (необовʼязково)',
          b2bMarketplaceMapConnectionPhotos: 'Фото точки приєднання',
          b2bMarketplaceMapParkingPhotos: 'Парковка',
          b2bMarketplaceMapKw: 'Потужність, {{value}} кВт',
          b2bLeadFormDistributionContractPhotosLabel: 'Фото договору на розподіл (необовʼязково)',
          b2bLeadFormDistanceLabel: 'Відстань до точки приєднання, м',
          b2bLeadFormDistancePlaceholder: 'Оберіть відстань',
          b2bLeadFormDistanceUpTo5: 'до 5 м',
          b2bLeadFormPriceKwhExtraLabel: 'Доплата за кВт·год',
          b2bLeadFormMonthlyParkingLabel: 'Місячна ціна за паркомісце',
          b2bMarketplaceTitle: 'Збережені локації',
          b2bMarketplaceSubtitle: 'Опубліковані пропозиції локацій без контактних даних',
          b2bMarketplaceMapHint: 'Натисніть маркер на карті, щоб переглянути деталі локації',
          b2bMarketplaceEmpty: 'Поки що немає опублікованих локацій',
          b2bMarketplaceLoadError: 'Не вдалося завантажити локації',
          b2bMarketplaceMapAria: 'Карта збережених локацій',
          b2bMarketplaceDetailTitle: 'Деталі локації',
          b2bMarketplacePublishedOn: 'Опубліковано {{timeAgo}}',
          b2bMarketplaceRequestInfo: 'Запросити інформацію',
          b2bMarketplaceOwnerInfoTitle: 'Контакти власника локації',
          b2bMarketplaceOwnerName: "Ім'я",
          b2bMarketplaceOwnerPhone: 'Телефон',
          b2bMarketplaceDistributionContractPhotosLabel: 'Фото договору на розподіл',
          b2bMarketplacePayFailed: 'Не вдалося оплатити доступ до інформації',
          b2bMarketplacePayProcessing: 'Оплату ще обробляють. Спробуйте оновити сторінку через хвилину.',
          b2bMarketplacePayTestSkip: 'Пропустити оплату (local test)',
          b2bMarketplaceViewedTimes: 'Переглянуто {{count}} разів',
          b2bMarketplaceContactTitle: 'Звʼязатися щодо цієї локації',
          b2bMarketplaceContactGreeting: 'Вітаю! Цікавить локація з маркетплейсу Вирій ЕМС.',
          b2bMarketplaceListingId: 'ID заявки',
          b2bMarketplaceClose: 'Закрити',
          b2bMarketplaceHeatmapLegendTitle: 'Попит на зарядку',
          b2bMarketplaceHeatmapLegendLow: 'менше',
          b2bMarketplaceHeatmapLegendHigh: 'більше',
          b2bAccordionLocationMarketplace: 'Маркетплейс локацій',
          b2bMarketplaceShareBtn: 'Поділитися',
          b2bMarketplaceShareCopied: 'Посилання скопійовано',
          b2bMarketplaceShareText: 'Маркетплейс локацій Вирій ЕМС',
          b2bSectionShareQrAlt: 'QR-код посилання на розділ B2B',
          b2bSectionShareCopyLink: 'Скопіювати посилання',
          b2bSectionShareOpenLink: 'Відкрити посилання',
          b2bAccordionTariffs: 'Тарифи на підключення ЕЗС',
          b2bTariffsShareText: 'Тарифи на підключення ЕЗС 220-km',
          b2bAccordionServiceRequest: 'Заявка на сервіс',
          b2bServiceRequestShareText: 'Прайс сервісних послуг 220-km',
          b2bServiceRequestOrderBtn: 'Замовити сервіс',
          b2bServiceRequestGreeting: 'Доброго дня! Хочу замовити сервіс зарядних станцій.',
          b2bAccordionDayAhead: 'РДН + накопичення енергії',
          b2bDayAheadShareText: 'РДН + накопичення енергії 220-km',
          b2bAccordionCaseBenny: 'Кейс: роумінг показав +18%',
          b2bCaseBennyShareText: 'Кейс 220-km: роумінг показав +18% на Benny 360 кВт',
          b2bAccordionCaseBakery: 'Кейс: пекарня, батарея до кінця циклу',
          b2bCaseBakeryShareText: 'Кейс 220-km: пекарня і заряд батареї',
          b2bAccordionCaseSolar: 'Кейс: сонце, динамічний тариф',
          b2bCaseSolarShareText: 'Кейс 220-km: сонце і динамічний тариф',
          b2bMessengerTelegram: 'Telegram',
          b2bMessengerWhatsApp: 'WhatsApp',
          b2bNewCabinetBtn: 'B2B кабінет Pro (beta)',
          b2bFlowGraphTitle: 'Діаграма потоку енергії',
          b2bFlowGraphSolar: 'Сонце',
          b2bFlowGraphWind: 'Вітер',
          b2bFlowGraphWindShareAria: 'Sirocco Energy — QR-код і посилання',
          b2bFlowGraphWindShareTitle: 'Sirocco Energy',
          b2bFlowGraphWindShareSubtitle: 'Відскануйте QR-код або скопіюйте посилання на документацію вітрової турбіни',
          b2bFlowGraphWindShareQrAlt: 'QR-код посилання на Sirocco Energy',
          b2bFlowGraphESS: 'УЗЕ',
          b2bFlowGraphEssVendorsTitle: 'Сумісні бренди УЗЕ',
          b2bFlowGraphEssVendorsAria: 'Показати логотипи виробників',
          b2bFlowGraphEssVendorShareCardAria: '{{vendor}} — QR-код і посилання на сайт виробника',
          b2bFlowGraphEssVendorShareTitle: '{{vendor}}',
          b2bFlowGraphEssVendorShareTitleFallback: 'Сумісні бренди УЗЕ',
          b2bFlowGraphEssVendorShareSubtitle: 'Відскануйте QR-код або скопіюйте посилання на сайт виробника',
          b2bFlowGraphEssVendorShareQrAlt: 'QR-код посилання на сайт {{vendor}}',
          b2bFlowGraphEssVendorOpensExternal: 'сайт виробника, нова вкладка',
          b2bFlowGraphEssCertificateCardAria: '{{vendor}} — сертифікат офіційного сервісного центру',
          b2bFlowGraphEssCertificateModalTitle: 'Сертифікат офіційного авторизованого сервісного центру',
          b2bFlowGraphEssCertificateImageAlt: 'Сертифікат офіційного сервісного центру {{vendor}}',
          b2bFlowGraphInverter: 'Інвертор',
          b2bFlowGraphEmsVpp: 'EMS + VPP',
          b2bFlowGraphEmsLinkText: 'EMS',
          b2bFlowGraphEmsVppSuffix: ' + VPP',
          b2bFlowGraphHubOpenEmsAria: '220-km.com — Open EMS, інтерфейс потоку енергії EMS + VPP (нова вкладка)',
          b2bFlowGraphGrid: 'Мережа',
          b2bFlowGraphCharging: 'EV Зарядка',
          b2bFlowGraphMiner: 'Майнер',
          b2bFlowGraphMinerShareAria: 'Binance Pool — QR-код і посилання',
          b2bFlowGraphMinerShareTitle: 'Binance Pool',
          b2bFlowGraphMinerShareSubtitle: 'Відскануйте QR-код або скопіюйте посилання на статистику майнера',
          b2bFlowGraphMinerShareQrAlt: 'QR-код посилання на Binance Pool',
          b2bFlowGraphESSCharging: 'Зарядка',
          b2bFlowGraphESSDischarging: 'Розрядка',
          b2bFlowGraphGridSelling: 'Продаж',
          b2bFlowGraphExpandWide: 'Розгорнути діаграму (широкий екран)',
          b2bFlowGraphCloseWide: 'Повернутися до сторінки',
          b2bFlowGraphUnitKw: 'кВт',
          b2bFlowGraphUnitMw: 'МВт',
          b2bRevenue: 'Загальний дохід',
          b2bEnergy: 'Заряджено',
          b2bAverageRate: 'Тариф',
          b2bDeposit: 'Оборотні кошти',
          b2bTariffs: {
            title: 'Тарифи на підключення ЕЗС',
            features: 'Можливості',
            tariffBase: 'Тариф Базовий 5%',
            tariffBaseName: 'Тариф Базовий',
            tariffBaseRate: '5%',
            tariffPro: 'Тариф Про 7%',
            tariffProName: 'Тариф Про',
            tariffProRate: '7%',
            tariffProPlus: 'Тариф Про+ 9%',
            tariffProPlusName: 'Тариф Про+',
            tariffProPlusEmsLabel: 'інтеграція з',
            tariffProPlusEmsName: 'Вирій EMS',
            tariffProPlusRate: '9%',
            feature1: 'Бізнес кабінет',
            feature2: 'Загальний телеграм бот служби турботи',
            feature3: 'Виплати раз на день на ФОП рахунок монобанк',
            feature4: 'Оновлення статусу раз на 30 секунд',
            feature15: 'Можливість налаштовувати індивідуальні та групові тарифи',
            feature5: 'Можливість підключати бюджетні китайські станції',
            feature6: 'Безкоштовне налаштування станції під ключ',
            feature7: 'Безкоштовні наліпки та мобільний звʼязок',
            feature8: 'Камера для VIP сервісу для Ваших водіїв',
            feature9: 'Окрема телеграм група підтримки + камера + фото статистика',
            feature11: 'Оновлення статусу раз на 5 секунд',
            feature12: 'Можливість підключити роумінг',
            feature13: 'Можливість отримувати виплати на будь який рахунок українського банку',
            feature14: 'Бронювання порту для водіїв',
            feature16: 'Пріорітетне вирішення сервісних питань',
            feature18: 'Динамічний тариф від SoC батареї або РДН',
            feature19: 'Інтеграція з Вирій EMS',
            feature20: 'Можливість створювати паливні картки',
          },
          months: {
            january: 'Січень',
            february: 'Лютий',
            march: 'Березень',
            april: 'Квітень',
            may: 'Травень',
            june: 'Червень',
            july: 'Липень',
            august: 'Серпень',
            september: 'Вересень',
            october: 'Жовтень',
            november: 'Листопад',
            december: 'Грудень',
          },
          monthsShort: {
            january: 'Січ',
            february: 'Лют',
            march: 'Бер',
            april: 'Кві',
            may: 'Тра',
            june: 'Чер',
            july: 'Лип',
            august: 'Сер',
            september: 'Вер',
            october: 'Жов',
            november: 'Лис',
            december: 'Гру',
          },
          teslaAdapterNotification: {
            title: 'Інструкція для американських авто з адаптером.',
            message: 'Якщо ви використовуєте адаптер з кнопкою, будь ласка, натисніть її один раз зараз!',
            button: 'Зрозуміло',
          },
          streetView: {
            title: 'Відкрити 3D перегляд?',
            yes: 'Так',
            no: 'Ні',
          },
          map: {
            distanceFromYou: '{{km}} км від вас',
            todayStatsTitle: 'Сьогодні:',
            todayDriven: 'Пройдено: {{km}} км',
            todaySpent: 'Витрачено: {{uah}} uah',
            todayDrivenCompact: '{{km}} км',
            todaySpentCompact: '{{uah}} uah',
            todaySpentPerKm: '{{value}} uah/км',
            speedCameraAhead: 'Камера попереду: {{meters}} м',
            speedLimit: 'Ліміт: {{limit}} км/год',
            warningAt: 'Попередження на: {{threshold}} км/год',
          },
          locationRequired: {
            title: 'Потрібен доступ до геолокації',
            description:
              'Для перегляду списку станцій необхідно дозволити доступ до вашого місцезнаходження. Це допоможе показати найближчі станції.',
            retry: 'Дозволити геолокацію',
            goToMap: 'Перейти до карти',
          },
          freeTestCharge: {
            title: 'Спробуйте безкоштовно!',
            description: 'Ми даруємо Вам першу зарядку безкоштовно, щоб переконатися, що все працює!',
            yesButton: 'Почати безкоштовно!',
            noButton: 'Ні, я оплачу сам',
          },
          quickStart: {
            button: 'Старт',
            headline: 'Вас вітає Мережа 220!',
            intro: 'Підключіть авто та натисніть старт.',
            afterSessionHint: "Після зупинки тестової сесії з'явиться кнопка «Оплатити».",
            description: 'Перший раз безкоштовно',
            defaultText: 'Вас вітає Мережа 220!',
          },
          reservation: {
            reserveButton: 'Забронювати ({{minutes}} хв)',
            btnReserve: 'Забронювати',
            btnReserveCooldown: 'Забронювати {{time}}',
            reservedByYou: 'Порт заброньовано вами',
            reservedByOther: 'Порт заброньовано іншим водієм',
            countdown: 'Залишилось: {{time}}',
            cancel: 'Скасувати бронювання',
            dailyLimitExceeded: 'Ліміт: лише 1 бронювання на добу',
            portAlreadyReserved: 'Порт уже заброньовано іншим водієм',
            notAllowed: 'Бронювання на цьому порті вимкнено',
            portBusy: 'Порт зараз заряджається, спробуйте пізніше',
            postJobCooldown: 'Бронювання доступне через 10 хвилин після завершення попередньої зарядки',
            nativeAppRequired: 'Бронювання доступне лише в додатку 220',
            notEligible: 'Бронювання доступне лише в додатку 220',
            webInstallAppPopup: 'Щоб користуватися бронюванням, встановіть додаток',
            webInstallAppBtn: 'Встановити додаток',
            failed: 'Не вдалося забронювати порт',
            detailsTitle: 'Бронювання',
            detailsPort: 'Порт #{{port}}',
            detailsDuration: '{{minutes}} хв',
            detailsDistance: '{{distance}} км від вас',
            detailsDistanceUnknown: 'Відстань невідома',
            detailsAttemptsLoading: '…',
            detailsAttempts: 'Бронювань сьогодні: {{used}}/{{max}}',
            detailsConfirm: 'Забронювати',
            detailsCancel: 'Скасувати',
            tooFar: 'Бронювання доступне лише в межах {{maxKm}} км від станції',
            locationRequired: 'Увімкніть геолокацію на карті, щоб забронювати порт',
          },
          restartStation: {
            button: 'Перезапустити станцію',
            confirmOcpp: 'Перезапустити ПОРТ # {{port}}?\n\n(ID пристрою скопійовано в буфер обміну)',
            confirmToka: 'Перезапустити зарядну станцію TOKA?',
            successOcpp: 'Команду перезапуску надіслано.',
            successToka: 'Станцію перезапущено. Команду надіслано.',
            errorFailed: 'Не вдалося перезапустити станцію. Спробуйте пізніше.',
          },
          dcChargingLoader: {
            starting: 'Запускаємо зарядку',
            title: 'Зарядка не розпочалася?',
            lead: 'Все ОК, будь ласка:',
            steps:
              'дістаньте конектор з машини > проїдьте 10 метрів > закрийте всі двері > та запустіть зарядку ще раз.',
          },
          freeChargeError: {
            title: 'Помилка',
            message: 'Занадто багато спроб безкоштовної зарядки',
          },
          rateLimitError: {
            title: 'Ліміт перевищено',
            message: 'Занадто багато запитів. Спробуйте пізніше.',
          },
          nativeAppFreeChargeError: {
            title: 'Недоступно в застосунку',
            message:
              'Безкоштовний швидкий старт у мобільному застосунку недоступний. Поповніть баланс через сайт 220-km.com або оберіть платну зарядку нижче.',
          },
          deployMaintenanceTitle: 'Все добре, ми оновлюємо сайт.',
          deployMaintenanceWait: 'Зачекайте ~30 секунд.',
          ...(portNotes.ua ? portNotes.ua : {}),
        },
      },
      ru: {
        translation: {
          slider: {
            kWhFor: 'кВт*г',
            aboutKm: 'около',
          },
          forKwh: 'за',
          btns: {
            start: ' часов',
            startKwt: ' кВт*ч',
            startFree: 'Попробовать бесплатно',
            startFullCharge: 'Быстрый старт',
            getAllStationsStatus: 'Показать все станции',
            getNearestStationsStatus: 'Станции рядом',
          },
          historyEmpty: 'История зарядок отсутствует',
          showPwaInstruction: 'Установить приложение',
          installApp: 'Установить приложение',
          installAppText: 'Приложение 220 не требует свободного места на вашем телефоне.',
          installAppTextSecond: 'Чтобы установить приложение, нажмите на инструкцию:',
          installAppTextThird:
            'После установки приложения 220, пожалуйста, используйте QR-сканер только из приложения.',
          installAppAttention: 'Внимание!',
          installAppButton: 'Установить приложение',
          installAppQrSectionLabel: 'QR-коды для установки приложения',
          installAppQrIosTitle: 'iOS',
          installAppQrIosSubtitle: 'App Store',
          installAppQrIosAlt: 'QR-код для установки из App Store',
          installAppQrPlayTitle: 'Android',
          installAppQrPlaySubtitle: 'Play Market',
          installAppQrPlayAlt: 'QR-код для установки из Google Play',
          installAppQrAndroidTitle: 'Android',
          installAppQrAndroidSubtitle: 'Скачать APK',
          installAppQrAndroidAlt: 'QR-код для скачивания APK',
          title: 'Заряди 220 километров за ночь',
          station: 'ПОРТ # ',
          feedbacks: 'Отзывы',
          leaveFeedback: 'Оставить отзыв',
          feedback: {
            leave: 'Оставить отзыв',
            title: 'Оставить отзыв',
            textLabel: 'Ваш отзыв',
            textPlaceholder: 'Расскажите о опыте на этой станции…',
            ratingLabel: 'Оценка',
            maxKwLabel: 'Макс. мощность авто',
            maxKwHint: 'кВт',
            kwUnit: 'кВт',
            carPhotoLabel: 'Фото авто у станции',
            choosePhoto: 'Выбрать фото',
            required: 'обязательно',
            optional: 'по желанию',
            photoRequiredNear: 'Вы рядом со станцией — добавьте фото авто.',
            removePhoto: 'Убрать фото',
            locating: 'Определяем вашу локацию…',
            submit: 'Отправить',
            successTitle: 'Спасибо!',
            successBody: 'Ваш отзыв отправлен.',
            askPromptTitle: 'Оставить отзыв?',
            askPromptBody: 'Поделитесь впечатлением об этой станции.',
            askPromptLeave: 'Оставить отзыв',
            askPromptClose: 'Закрыть',
            askPromptDontAsk: 'Не спрашивать 30 дней',
            listTitle: 'Отзывы',
            teamLabel: 'Ответ команды 220',
            empty: 'Пока нет отзывов',
            compose: 'Написать отзыв',
            avgAria: 'Средняя оценка {{rating}}',
            reviewsCount: '{{count}} отзывов',
            prev: 'Назад',
            next: 'Дальше',
            pageOf: '{{page}} / {{pages}}',
            carPower: '{{kw}} кВт',
            errors: {
              rateLimited: 'Можно оставить не больше 2 отзывов в сутки.',
              paymentRequired: 'Отзыв можно оставить после успешной оплаты на этой станции.',
              photoRequired: 'Добавьте фото авто у станции.',
              tooLarge: 'Файл слишком большой. Попробуйте другое фото.',
              generic: 'Не удалось отправить отзыв. Попробуйте ещё раз.',
            },
          },
          serviceRequestForm: {
            title: 'Заявка на сервис',
            problemTypesLabel: 'Тип проблемы',
            problemTypes: {
              port_not_working: 'Не работает зарядный порт',
              station_offline: 'Станция не отвечает/выключена',
              cable_damage: 'Повреждение кабеля/разъёма',
              payment: 'Проблема с оплатой',
              other: 'Другое',
            },
            portLabel: 'Номер порта',
            cityLabel: 'Город',
            cityPlaceholder: 'Город станции',
            descriptionLabel: 'Описание проблемы',
            descriptionPlaceholder: 'Опишите, что произошло…',
            descriptionHint: 'Укажите марку/модель/год авто, тип разъёма и переходник, если есть.',
            phoneLabel: 'Телефон',
            phonePlaceholder: '+380…',
            photosLabel: 'Обязательные фото',
            photoSlots: {
              car_port: 'Фото порта авто / адаптера + VIN',
              car: 'Фото авто',
              station: 'Фото номера станции / ошибки на экране',
            },
            removePhoto: 'Убрать фото',
            optional: 'по желанию',
            submit: 'Отправить',
            successTitle: 'Заявка отправлена',
            successBody: 'Мы свяжемся с вами в ближайшее время.',
            listTitle: 'Заявки на сервис',
            empty: 'Пока нет заявок',
            compose: 'Новая заявка',
            errors: {
              rateLimited: 'Можно отправить не больше 2 заявок на сервис в сутки.',
              problemRequired: 'Выберите тип проблемы.',
              portRequired: 'Укажите номер порта.',
              descriptionRequired: 'Опишите проблему, минимум 5 символов.',
              phoneRequired: 'Укажите номер телефона.',
              invalidPhone: 'Проверьте номер телефона.',
              photoRequired: 'Добавьте это фото.',
              tooLarge: 'Файлы слишком большие. Попробуйте другие фото.',
              photosRequired: 'Добавьте фото авто.',
              generic: 'Не удалось отправить заявку. Попробуйте ещё раз.',
            },
          },
          refundForm: {
            title: 'Возврат средств',
            portLabel: 'Номер порта',
            portPlaceholder: 'ПОРТ # на станции или 220-km.com',
            fullNameLabel: 'Полное имя',
            fullNamePlaceholder: 'Фамилия и имя',
            reasonLabel: 'Тип причины',
            problemTypesLabel: 'Выберите тип проблемы, с которой вы столкнулись (можно несколько)',
            problemTypesPlaceholder: 'Выберите тип проблемы',
            problemTypes: {
              port_not_working: 'Не работает зарядный порт',
              station_offline: 'Станция не отвечает/выключена',
              cable_damage: 'Повреждение кабеля/разъёма',
              payment: 'Проблема с оплатой',
              other: "Другое (опишите в поле 'Описание причины')",
            },
            phoneLabel: 'Номер телефона',
            phonePlaceholder: '+380…',
            descriptionLabel: 'Описание причины возврата',
            descriptionPlaceholder: 'Опишите ситуацию…',
            descriptionHint:
              'При неуспешной зарядке укажите марку, модель и год авто, тип коннектора и переходник (с кнопкой или без для Tesla).',
            cardLabel: 'Номер карты для возврата',
            cardPlaceholder: '16 цифр',
            amountLabel: 'Сумма возврата (грн)',
            amountPlaceholder: '0.00',
            contactedLabel: 'Обращались ли в поддержку 220 по телефону?',
            yes: 'Да',
            no: 'Нет',
            ratingLabel: 'Оценка процесса зарядки',
            photosLabel: 'Обязательные фото',
            photoSlots: {
              receipt: 'Банковский чек оплаты',
              car: 'Фото авто / порта / ошибки на дисплее',
            },
            removePhoto: 'Убрать фото',
            optional: 'по желанию',
            submit: 'Отправить заявку',
            successTitle: 'Заявка отправлена',
            successBody: 'Мы проверим платёж и вернём средства на карту.',
            manualHint: 'Новый телефон или нет сессии в истории — заполните все поля ниже.',
            termsSummary: 'Возврат на карту регулируется <termsLink>публичным договором (п. 7.3–7.4)</termsLink>.',
            terms73:
              'Заявку рассматривает Агрегатор. Срок рассмотрения — до 60 рабочих дней в зависимости от банка Пользователя. Агрегатор старается обработать обращение быстрее. Если возвращённые средства уже были зачислены Исполнителю, Агрегатор вправе удержать эту сумму из дальнейших расчётов с Исполнителем.',
            terms74: 'В заявке укажите телефон и причину. Сессия привязывается автоматически по оплате (invoice).',
            recoverAlternative:
              'Более быстрая альтернатива: восстановите виртуальный баланс по квитанции — средства можно сразу использовать на следующую зарядку.',
            noSessionBody: 'Нет сессии для возврата. Напишите в поддержку номер порта и квитанцию из банка.',
            button: 'Возврат',
            errors: {
              incomplete: 'Заполните обязательные поля',
              portRequired: 'Укажите номер порта',
              nameRequired: 'Укажите полное имя',
              phoneRequired: 'Укажите телефон',
              phoneInvalid: 'Проверьте номер телефона',
              reasonRequired: 'Выберите тип проблемы',
              descriptionRequired: 'Опишите причину (мин. 10 символов)',
              cardRequired: 'Укажите номер карты (13–19 цифр)',
              amountRequired: 'Укажите сумму в грн',
              contactedRequired: 'Укажите, обращались ли в поддержку',
              ratingRequired: 'Оцените процесс зарядки (1–5)',
              receiptPhotoRequired: 'Добавьте банковский чек',
              carPhotoRequired: 'Добавьте фото авто / порта / ошибки',
              rateLimited: 'Можно отправить не больше 2 заявок на возврат в сутки.',
              invalidPhone: 'Проверьте номер телефона.',
              duplicate: 'Заявка по этой оплате уже отправлена.',
              tooLarge: 'Файл слишком большой. Попробуйте другое фото.',
              generic: 'Не удалось отправить заявку. Попробуйте ещё раз.',
            },
          },
          chargeLink: 'Зарядка',
          landingLink: 'Список станций',
          landingLinkMap: 'Карта станций',
          contacts: 'Связаться с нами',
          buyUps: 'Купить ИБП',
          chooseVolume: 'Выбрать',
          history: 'История зарядок',
          offer: 'Оферта',
          terms: {
            tabs: {
              driver: 'Для водителей',
              stationOwner: 'Для владельцев станций',
            },
            stationOwnerTitle: 'ПУБЛИЧНАЯ ОФЕРТА\nДЛЯ ВЛАДЕЛЬЦЕВ ЗАРЯДНЫХ СТАНЦИЙ В СЕТИ 220-km.com',
            stationOwnerIntro:
              'Этот документ определяет условия сотрудничества между Заказчиком (владельцем станции) и ФЛП Павловым Максимом Валерьевичем по доступу к API 220-km.com под Банк.',
          },
          b2bContract: {
            tariffsLinkIntro: 'Подробное описание тарифов и возможностей можно найти на',
            tariffsLinkLabel: 'странице 220-km.com/b2b',
          },
          wt: 'кВт*ч',
          powerWt: ' кВт',
          maxPower: 'выдаёт до:',
          maxPowerSticker: 'max {{kw}} kW',
          maxPowerStickerAria: 'Максимальная мощность {{kw}} кВт',
          maxPowerStickerRangeAria: 'Мощность {{minKw}}–{{maxKw}} кВт',
          portPriceStickerAria: 'Тариф {{price}} {{unit}} за кВт·ч',
          portPriceStickerScheduleAria: 'Тариф {{price}} {{unit}} за кВт·ч, показать расписание динамического тарифа',
          portPriceStickerUnit: 'грн',
          plugTypeNoCable: 'без кабеля',
          dynamicTariffScheduleTitle: 'Динамический тариф',
          portCardOpenStartManyAria: 'Открыть все порты устройства, порт {{stationNumber}}',

          energy: 'кВт',
          energyKwh: ' кВт*ч',
          balance: 'Баланс:',
          balanceNe: 'не',
          balanceWord: 'баланс:',
          energyCard: {
            label: 'energy card',
            kwhForPorts: 'кВт⋅ч для зарядки на портах',
            uahForPorts: 'грн для зарядки на портах',
            chargeWithEc: 'Зарядить с Топливной карты',
            validUntil: 'действительна до',
            brandedName: 'Топливная карта на {{kwh}} kWh от 220-km.com',
            brandedNameUah: 'Топливная карта на {{uah}} грн от 220-km.com',
            cardId: 'ID карты',
            archived: 'Архивные карты',
            usedKwh: 'использовано',
            leftKwh: 'осталось',
            usedLeftLabel: '{{used}} / {{left}} кВт⋅ч',
            usedLeftLabelUah: '{{used}} / {{left}} грн',
            chargingOnPort: 'зарядка на порту #{{port}}',
            clickPortForDetails: 'Нажмите на номер порта, чтобы открыть детали',
            remainingUahHint: 'остаток {{uah}} грн',
          },
          currency: ' грн',
          portraitOnlyMessage: 'Поверните устройство вертикально',
          portraitOnlyHint: 'Приложение работает только в портретном режиме',
          payedForKwh: 'Оплачено',
          spent: 'Потрачено',
          v: 'В',
          km: ' км',
          chargedCongrats: 'Поздравляем!',
          chargedkWt: 'Заряжено: ',
          startNew: 'Хочу еще раз',
          stationStoppedCharging: 'Станция остановила зарядку: {{detail}}',
          power: 'Мощность',
          powerExceededError: 'Пожалуйста, уменьшите мощность и попробуйте снова:',
          onlineStatus: 'Офлайн',
          powerKm: 'км/ч',
          charging: 'Заряжено',
          openPowerHistoryChart: 'Открыть график мощности',
          powerCurveSessionOnly: 'График мощности доступен только для вашей сессии',
          voltage: 'Вольтаж',
          chargingSpeed: 'Скорость заряда',
          solar: 'Солнце',
          bess: 'УЗЭ',
          bessReserveSource: 'Резервное питание',
          stationAdditionalSourceBess: 'Эта станция имеет резервное питание',
          batteryDischarge: 'Аккумулятор',
          batteryCharging: 'заряжается',
          openEmsInverterLinkAria: 'Открыть Open EMS для инвертора {{kwh}} кВт·ч',
          renewable: 'зелёная энергия',
          batterySocPct: 'SoC {{pct}}%',
          solarInsolationTomorrowLine: 'Завтра {{pct}}%',
          solarInsolationToday: 'Сегодня',
          solarInsolationTomorrow: 'Завтра',
          solarInsolationForecast: 'Солнце сегодня и завтра',
          solarInsolationDayGraphAria: 'Почасовой прогноз инсоляции на сегодня для локации порта',
          solarInsolationTomorrowGraphAria: 'Почасовой прогноз инсоляции на завтра для локации порта',
          getBloodyLitersSaved: 'Сэкономлено',
          bloodyLitersLink: 'https://youtu.be/T0wK0VPy-V0?si=c9daReLH709PYE9q&t=83',
          noNearestStations: 'Рядом с вами станций не обнаружено',
          getDirection: 'Получить маршрут',
          route: 'Маршрут',
          outageSchedule: {
            button: 'График отключений',
            title: 'График отключений',
            loading: 'Запрашиваем график…',
            group: 'Группа {{group}}',
            today: 'Сегодня',
            tomorrow: 'Завтра',
            noOutages: 'Плановых отключений нет',
            waiting: 'График ещё не опубликован',
            emergency: 'Экстренные отключения',
            updated: 'Обновлено {{time}}',
            allGroups: 'Одинаковый для всех групп',
            queuesHint: 'Улица не распознана. Выберите группу:',
            chooseGroup: 'Выберите группу:',
            anotherGroup: 'Другая группа',
            unsupported: 'Для этой области графика нет.',
            groupUnknown: 'График публикуется по очереди. По GPS очередь определить нельзя.',
            notFound: 'Не удалось найти дом по координатам порта.',
            error: 'Не удалось получить график. Попробуйте ещё раз.',
          },
          photo: 'Описание локации',
          distanceKm: ' км',
          distanceM: 'м',
          locationError: 'Включите доступ к местоположению в настройках браузера.',
          mapFarGpsAirAlert: 'Воздушная тревога в вашем регионе, пожалуйста, найдите ближайшее укрытие.',
          mapFarGpsAirAlertDismiss: 'Понятно',
          toHomePage: 'Станции рядом',
          allStations80Plus: 'Все быстрые станции',
          allStationsEvboost: 'Все станции',
          recoverBalance: 'Восстановить баланс',
          recoverBalanceAutomatically: 'Восстановить баланс',
          recoverBalanceUploadHint:
            'Загрузите скриншот оплаты из банка (монобанк, ПриватБанк и т.д.). Сумму в гривнах распознаем автоматически.',
          recoverBalanceSelectFile: 'Загрузить скриншот',
          recoverBalanceSubmit: 'Восстановить',
          recoverBalanceManualFallback: 'Оформить заявку вручную',
          recoverBalanceError: {
            PARSE_FAILED: 'Не удалось распознать сумму с фото. Попробуйте более чёткий скриншот.',
            ORDER_NOT_FOUND: 'Заказ с такой суммой не найден. Проверьте квитанцию.',
            ALREADY_RECOVERED: 'Нельзя восстановить одну и ту же квитанцию много раз.',
            NO_IMAGE: 'Выберите скриншот квитанции.',
            RATE_LIMITED: 'Слишком много попыток. Попробуйте завтра.',
            NATIVE_APP_REQUIRED: 'Восстановление баланса доступно только в приложении 220.',
            UNKNOWN: 'Ошибка. Попробуйте позже.',
          },
          serviceRequest: 'Сервис',
          notifyWhenOnline: 'Сообщить, когда заработает',
          notifyWhenFinish: 'Сообщить о завершении',
          freshPorts: 'Со Светом',
          online: 'Онлайн',
          offline: 'Офлайн',
          seconds: 'сек',
          minutes: 'мин',
          hours: 'час',
          days: 'дн',
          allCars: 'Авто из Китая',
          china: 'Авто из Китая',
          allPorts: 'Все Порты',
          onlyFast: 'Быстрые зарядные',
          filter80Kw: '+ Роуминг',
          filter160Kw: '160+ кВт',
          filterFast: 'Быстрые',
          filterSlow: 'Медленные',
          filterChina: 'Китайские порты',
          filterNacs: 'NACS',
          filterCheapest: 'Самые дешёвые',
          filterEuropean: 'Европа и Америка',
          filterOnline: 'Со Светом',
          єСвітло: 'Со Светом',
          mapPortSearchPlaceholder: '№ порта',
          mapPortSearchNoResults: 'Порт не найден',
          mapPortSearchLoading: 'Поиск…',
          mapPortSearchRoute: 'Маршрут',
          openMapsTitle: 'Открыть маршрут',
          openMapsInWaze: 'Навигация в Waze',
          openMapsInGoogle: 'Навигация в Google',
          openMapsInEvua: 'Открыть в EV UA',
          openMapsEvuaDetailsLoading: 'Загрузка деталей…',
          openMapsEvuaDetailsEmpty: 'Детали станции недоступны',
          openMapsEvuaOperator: 'Оператор',
          openMapsEvuaProvider: 'Провайдер',
          openMapsEvuaVendor: 'Производитель',
          openMapsEvuaConnectors: 'Разъёмы',
          openMapsEvuaPrice: 'Тариф',
          openMapsEvuaPriceValue: '{{price}} грн/кВт·ч',
          openMapsEvuaPower: 'Мощность',
          openMapsEvuaPowerValue: '{{power}} кВт',
          openMapsEvuaStationId: 'ID',
          openMapsEvuaCoords: 'Координаты',
          stationListSearchPlaceholder: 'Поиск',
          stationListSearchNoResults: 'Станций по запросу не найдено',
          listOpenEmsEvPowerTitle: 'Зарядка EV',
          listOpenEmsEvPowerTariff: '{{value}} грн/кВт·ч',
          listOpenEmsEvPowerSessions: '{{count}} активных сессий',
          listOpenEmsEvPowerAria: 'Суммарная мощность зарядки EV из Open EMS',
          listOpenEmsGreenEnergyAria: 'Доля зелёной энергии зарядной сети из Open EMS',
          listOpenEmsBannerAria: 'Зелёная энергия, суммарная мощность и активные сессии зарядки из Open EMS',
          startPageShareBtn: 'Поделиться портом',
          startPageShareTitle: 'ПОРТ #{{port}}',
          startPageShareText: 'Зарядная станция 220-km — порт №{{port}}',
          startPageShareQrAlt: 'QR-код ссылки на порт',
          startPageShareStickerPreviewAlt: 'Предпросмотр PNG-стикера порта №{{port}}',
          startPageSharePortTypeWithPower: 'Тип разъёма: {{type}} · {{kw}} kW',
          startPageSharePortTypeOnly: 'Тип разъёма: {{type}}',
          startPageSharePortPowerOnly: 'Мощность: {{kw}} kW',
          startPageShareStickerPortLabel: 'ПОРТ # ',
          startPageShareStickerDownload: 'Скачать PNG-стикер',
          startPageShareStickerDownloading: 'Готовим PNG…',
          startPageShareStickerError: 'Не удалось создать PNG-стикер',
          startPageSharePrintOrder: 'Заказать печать: @kpiprint1',

          login: 'Войти с Google',
          loginTitle: 'Добро пожаловать',
          loginText: 'Войдите, чтобы продолжить',

          logout: 'Выйти',

          userInfoName: 'Вы вошли как',

          historyPage: {
            station: 'ПОРТ #',
            openPort: 'Открыть ПОРТ #',
            amountS: 'Длительность',
            avgPower: 'Ср. мощность',
            price: 'Оплачено',
            spendEnergy: 'Потрачено энергии',
            finished: 'Завершено',
            refund: 'Возвращено',
            bankRefund: 'Возвращено на карту',
            bankRefundStatus: 'Возврат на карту',
            bankRefundSuccess: 'Возвращено',
            balance: 'Баланс',
            state: 'Статус',
            timeHours: 'ч',
            timeMinutes: 'мин',
            receipt: 'Квитанция',
            loading: 'Загрузка...',
            receiptError: 'Ошибка загрузки чека',
            clientUiId: 'ID клиента',
            copyClientId: 'Скопировать ID клиента',
            copiedToClipboard: 'Скопировано в буфер обмена!',
            clientOs: 'Операционная система',
            clientIdQrTitle: 'Хотите поделиться балансом и историей с другом или семьёй?',
            clientIdQrSubtitle: 'Просто отсканируйте QR с телефона друга!',
            clientIdQrAlt: 'QR код клиента',
            toggleClientIdQr: 'Показать QR клиента',
            createFamily: 'Дать доступ к балансу',
            scanClientIdQr: 'Сканировать QR-код друга',
            loadClientIdQrFromPhoto: 'Импортировать фото QR-кода',
            loadClientIdQrFromPhotoError: 'Не удалось распознать QR на фото. Попробуйте другой скриншот.',
            powerCurve: 'График мощности',
            power: 'Мощность',
            voltage: 'Напряжение',
            soc: 'SOC',
            summaryTimeSpent: 'Время зарядки',
            summarySocLabel: 'SoC',
            summarySocLine: 'старт {{started}}% + {{charged}}% = {{total}}%',
            summaryAvgPower: 'Ср. мощность',
            summaryPeakPower: 'Пиковая мощность',
            min: 'Мин',
            max: 'Макс',
            avg: 'Ср',
            noPowerData: 'Нет данных кривой',
            powerCurvePending: 'График появится после 10 мин зарядки',
            revenueChartLast6Months: 'Последние 6 месяцев',
            revenueChartPrevious6Months: 'Предыдущие 6 месяцев',
            revenueChartMonthAxis: 'Месяц',
            revenueChartTooltipCharged: 'Заряжено',
            revenueChartTooltipSpent: 'Потрачено',
            revenueChartTooltipAvgPower: 'Ср. мощность',
            revenueChartTotalCharged: 'Заряжено',
            revenueChartLitersUnit: 'Л A-95',
            revenueChartSavedCo2: 'CO₂',
            revenueChartCo2Unit: 'т',
            revenueChartSummaryAria: 'Итоги',
            loadOlderSessions: 'Более старые сессии',
          },
          kW: 'кВт',

          stopButton: 'Стоп',
          stopChargingConfirm: {
            title: 'Остановить зарядку?',
            message: 'Зарядка будет завершена. Продолжить?',
            cancel: 'Отмена',
            error: 'Не удалось остановить зарядку. Попробуйте ещё раз.',
          },
          startButton: 'Старт',
          refresh: 'Обновить',

          qrScanner: {
            nameButton: 'Сканировать QR-код',
            backButton: 'Назад',
            cameraPermissionAlert: 'Пожалуйста, разрешите доступ к камере и обновите страницу',
            cameraUnavailable:
              'Камера доступна только через HTTPS. Откройте https://localhost:3000/scanner или вставьте текст QR ниже.',
            pasteClientIdHint: 'Вставьте QR клиента (220km-client-id:...)',
            importClientIdButton: 'Импортировать',
            scanHint: 'Наведите QR-код на центральную рамку',
            scanning: 'Сканирование',
            invalidTokaUrl: 'Неверная ссылка Toka',
            tokaNotFound: 'Порты 220 для этой станции Toka не найдены',
            tokaLookupError: 'Не удалось найти порты 220 для Toka',
            tokaErrorDetail: 'Порты 220 для станции Toka #{{tokaNumber}} не найдены. Ссылка: {{url}}',
            tokaInvalidUrlDetail: 'Неверная ссылка Toka: {{url}}',
            clientIdInvalid: 'QR клиента не распознан',
            energyCardInvalid: 'QR Energy Card не распознан',
            energyCardActivateError: 'Не удалось активировать Energy Card',
            energyCardAlreadyScanned: 'Топливная карта уже отсканирована',
            energyCardWebInstallPopup: 'Пожалуйста, установите нативное приложение и сканируйте из него',
            loadFromPhoto: 'Импортировать фото QR-кода',
            loadingFromPhoto: 'Чтение QR…',
            loadFromPhotoError: 'Не удалось распознать QR на фото. Попробуйте другой скриншот.',
          },

          errorStart: {
            portConnectedQuestion: 'Вы подключили порт №{{portNumber}} к своему автомобилю?',
            ifSoPleaseDo: 'Если да, пожалуйста:',
            alertMessage: 'Отключите и подключите разъём к автомобилю',
          },

          inServiceWarning: 'Этот порт может работать некорректно',
          portInServiceSince: 'Порт на обслуживании с {{date}}',
          portInService: 'Порт на обслуживании',
          portInRepairForDays: 'в ремонте {{daysText}}',

          error: 'Ошибка',
          errorDevHeader: 'Ошибка сервера',
          errorDevBody: 'Мы уже решаем проблему и скоро вернемся :)',
          errorOfflineHeader: 'ПОРТ # <1>{{stationNumber}}</1> офлайн :(',
          errorOfflineBody: 'Нет света или не в сети',
          errorOfflineDcEmergencyHint: 'Пожалуйста, проверьте, отжата ли красная аварийная кнопка на станции',
          errorPayHeader: 'Оплата недоступна!',
          errorPayBody: 'Мы уже решаем проблему и скоро вернемся :)',
          paymentNotConfigured: 'Оплата не настроена',
          errorStartFailedHeader: 'Ой, проблема :( Проверьте номер ПОРТА и попробуйте снова :)',
          errorStartFailedBody: '',
          errorFingerPrintUndefindHeader: 'Обнаружен блокировщик рекламы',
          errorFingerPrintUndefindBody: 'Пожалуйста, отключите его и попробуйте снова',
          errorFingerPrintUnavailableHeader: 'Бесплатная зарядка уже использована',
          errorFingerPrintUnavailableBody: 'Пожалуйста, произведите оплату :)',

          stationOffline: 'Не в сети',
          noInternetConnection: 'Нет подключения к интернету',
          serverConnectionChecking: 'Проверка соединения с сервером...',
          serverConnectionError: 'Нет соединения с сервером, попробуйте зайти с мобильного интернета',
          ipBlockedError: {
            title: 'Доступ заблокирован',
            message: 'Ваш IP-адрес {{ip}} заблокирован',
          },
          offlineForDays: '{{days}} дней',

          costPerHour: ' грн за час',
          costPerKwt: ' грн за кВт',
          costPerKwtAlt: ' грн за кВт',
          costPerKwtH: ' грн за кВт*ч',

          roamingWithToka: 'роуминг с toka',

          readyForUse: 'Свободен!',
          listPortConnectedToCar: 'Подключено к авто',
          listPortAvailable: 'Доступен',
          ready: 'ГОТОВ',
          connected: 'ПОДКЛЮЧЕНО',
          inProgress: 'ЗАРЯДКА',
          selectPort: 'Please select PORT',
          noPortsFound: 'Порты не найдены',
          noPortsSpecified: 'Пожалуйста, укажите порты в URL',
          goToPort: 'Перейти к ПОРТУ',
          startManyRegionUnknown: 'Украина',
          startManyRegionTapForStatus: 'Показать статус: {{status}}',
          startManySheetExpandMap: 'Показать карту',
          startManySheetCollapseMap: 'Скрыть карту',
          startManySheetHintUp: 'Проведите вверх — карта',
          startManySheetHintDown: 'Проведите вниз — порты',
          startManyShareBtn: 'Поделиться станцией',
          startManyShareTitle: 'Станция 220-km.com',
          startManyShareText: 'Зарядная станция 220-km.com — порты {{ports}}',
          startManyShareQrAlt: 'QR-код ссылки на станцию',
          startManyMaxPower: 'Макс. мощность',
          startManyPricePerKwh: '{{price}} грн за 1 кВт·ч',

          calibration: 'Откалибруйте результат!',
          enterYourKm: 'Пожалуйста, введите заряженные километры',
          sendKm: 'Калибровать',
          calibratedKm: 'Ваш результат откалиброван',
          btnRepeat: 'Повторить',

          featureInProgress: 'Ожидайте в следующем обновлении :)',

          back: 'Вернуться',
          close: 'Закрыть',
          photoSource: {
            title: 'Скриншот QR лежит в библиотеке фото',
            library: 'Загрузить из библиотеки',
            cancel: 'Отмена',
          },
          delayedStart: 'Зарядка начнется в <1>{{openFrom}}</1>',
          beforePayInfoKwh: 'Оплатить зарядную сессию',
          beforePayInfo: 'Рекомендуем выбирать минимальный объем, чтобы НЕ накапливать лишний баланс.',
          beforeStartInfo: 'Начать зарядную сессию',
          cancelDelayedStart: 'Отменить',
          delayedInfo: 'Работает с <1>{{openFrom}}</1> до <1>{{closedFrom}}</1>',
          leftBeforeStart: 'До начала осталось:',
          startAt: 'Начнется в <1>{{openFrom}}</1>',
          stationCardInfo: 'с <1>{{openFrom}}</1> до <1>{{closedFrom}}</1>',

          offerTitle: 'ПУБЛИЧНАЯ ОФЕРТА',
          callUs: 'Позвонить',
          contactUs: 'Связаться с нами',
          instagram: 'Инстаграм',
          telegram: 'Телеграм Бот',
          whatsApp: 'Ватсап',
          tapCall: 'Позвонить',
          tapChatBot: 'Получить помощь через чат',
          telHlib: 'Глеб',
          telMax: 'Макс',
          notFound: 'Страница не найдена',
          btnPay: 'Оплатить',
          btnPayFor: 'Старт',
          guestPay: {
            title: 'Оплатить в гостевом режиме?',
            yes: 'Да',
          },
          driverTermsAccept: {
            label: 'Я согласен с <termsLink>условиями договора</termsLink>',
            popupText: 'Чтобы продолжить, согласитесь с <termsLink>условиями договора</termsLink>',
            agree: 'Согласен',
          },
          overload: {
            waitForLink: 'Подождите секунду',
            gettingLink: 'Получаем ссылку для оплаты',
            successChecked: 'Успешно',
            letsCharge: 'Поехали заряжаться',
            checking: 'проверяем нагрузку',
            overloadDetected: 'Обнаружено перегрузка',
            slowdown: 'Пожалуйста, уменьшите напряжение до',
            repeat: 'и попробуйте снова',
          },
          footer: {
            part1: 'Все права защищены',
            part2: 'Разработано',
            part3: 'с ♥ к электромобилям',
          },

          b2bHeader: 'Для бизнеса',
          b2bHeaderNew: 'Для бизнеса (beta)',
          microgridHeader: 'Энергонезависимость',
          b2bWelcomeTitle: 'B2B для владельцев зарядных станций',
          b2bSeoMetaDescription:
            'B2B 220-km.com: статистика зарядных станций, тарифы, РДН/ВДР (OREE), диаграмма потока энергии EMS + VPP. Open EMS — система умного управления энергией для микросетей (СЭС, BESS, EV): автоматизированное сценарное управление заряд/разряд, арбитраж на РДН и ВДР, ML-прогноз генерации и цен, Modbus/MQTT/OPC UA, островной режим. https://github.com/220-organization/open-ems. Данные 220-km.com проанализированы в статье ИЭД НАН Украины о динамическом ценообразовании на ЭЗС и балансировании ОЭС (порт 2005, Южноукраинск, 2025).',
          b2bSeoMetaKeywords:
            'система умного управления энергией, микросеть EMS, мониторинг BESS, мониторинг СЭС, ML-прогноз солнечной генерации, ML-прогноз цен РДН, арбитраж РДН ВДР, активный потребитель, островной режим, Modbus MQTT OPC UA, Open EMS, EMS Ukraine, VPP, РДН, ВДР, OREE, энергоменеджмент, зарядные станции B2B, 220-km, Deye, Huawei FusionSolar, smart charging, B2B API, ИЭД НАН Украины, балансирование ОЭС, дешева зарядка, найдешевша зарядка, де зарядитись при вимкненні світла',
          b2bFlowGraphSeoMetaDescription:
            'Диаграмма потока энергии 220-km.com: smart EMS для микросетей — СЭС, BESS, зарядка EV, арбитраж РДН/ВДР, ML-прогноз. Open EMS (open-source): https://github.com/220-organization/open-ems',
          b2bMarketplaceSeoTitle: 'Где установить зарядную станцию — маркетплейс локаций',
          b2bMarketplaceSeoMetaDescription:
            'Маркетплейс локаций 220-km.com для владельцев зарядных станций: найдите, где установить зарядную станцию — карта спроса на зарядку по Украине, готовые локации под зарядные хабы с договором с облэнерго. Альтернатива сетям OKKO, AYONIT, Ionity: выберите точку, договоритесь с владельцем участка и запустите быструю EV-зарядку.',
          b2bMarketplaceSeoMetaKeywords:
            'где установить зарядную станцию, зарядные хабы, маркетплейс локаций для зарядных станций, локация под зарядную станцию, аренда места под ЭЗС, карта спроса на зарядку EV, OKKO зарядные станции, AYONIT, айонит, Ionity, договор с облэнерго, быстрая зарядка EV, инвестиции в зарядные станции, бизнес на зарядных станциях, 220-km',
          b2bWelcomeText: 'Войдите в кабинет 220-km.com для просмотра статистики и управления станциями.',
          b2bEvDriversCountTotal: 'Количество пользователей: {{count}}',
          b2bEvDriversCountInMonth: ' в {{month}}',
          b2bMonthJan: 'январе',
          b2bMonthFeb: 'феврале',
          b2bMonthMar: 'марте',
          b2bMonthApr: 'апреле',
          b2bMonthMay: 'мае',
          b2bMonthJun: 'июне',
          b2bMonthJul: 'июле',
          b2bMonthAug: 'августе',
          b2bMonthSep: 'сентябре',
          b2bMonthOct: 'октябре',
          b2bMonthNov: 'ноябре',
          b2bMonthDec: 'декабре',
          b2bEnterCabinetBtn: 'Войти в кабинет',
          b2bTariffsLink: 'Тарифы и возможности',
          b2bStatsAvgRate7Days: 'Средний тариф за 7 дней (грн/кВт⋅ч)',
          b2bStatsAvgRate30Days: 'Средний тариф за 30 дней (грн/кВт⋅ч)',
          b2bStatsPerDay: 'За день',
          b2bStatsPerMonth: 'За месяц',
          b2bStatsAvgRateForPeriod: 'Средний тариф за {{period}} (грн/кВт⋅ч)',
          b2bStatsAvgRateLabel: 'Средний тариф в роуминговой сети 220-km.com',
          b2bStatsAvgRateLabelFor: 'за',
          b2bStatsAvgRateValueWithUnit: '{{value}} грн/кВт⋅г',
          b2bStatsTrendVsDayBefore: 'к предыдущему дню',
          b2bStatsTrendVsMonthBefore: 'к предыдущему месяцу',
          b2bMonthPickerThisMonth: 'Текущий месяц',
          b2bMonthPickerPrevYear: 'Предыдущий год',
          b2bMonthPickerNextYear: 'Следующий год',
          b2bOreePriceIndicesTitle: 'Индексы цен (OREE)',
          b2bOreePriceIndicesOpen: 'Открыть на oree.com.ua',
          b2bOpenEmsMonthlyRatesTitle: 'Тариф',
          b2bOpenEmsMonthlyRatesSubtitle: 'Средний тариф для бизнеса с распределением и НДС',
          b2bOpenEmsMonthlyRatesOpen: 'Открыть Open EMS',
          b2bOpenEmsMonthlyRatesUnit: '/кВт*ч',
          b2bOpenEmsMonthlyRatesVsPrev: 'в сравнении с {{month}}',
          b2bOpenEmsMonthlyRatesNoComparison: 'Без сравнения',
          b2bOpenEmsMonthlyRatesPending: '...',
          b2bDayKwhChartTitle: '220 почасовые объёмы',
          b2bDayKwhChartMarketShare: 'Доля рынка Украины: ~ {{pct}}',
          b2bDayKwhChartDateLabel: 'Дата',
          b2bDatePickerToday: 'Сегодня',
          b2bDatePickerPrevMonth: 'Предыдущий месяц',
          b2bDatePickerNextMonth: 'Следующий месяц',
          b2bDatePickerPrevDay: 'Предыдущий день',
          b2bDatePickerNextDay: 'Следующий день',
          b2bTomorrowChartGateTitle: 'Данные на завтра — только после контакта',
          b2bTomorrowChartGateBody:
            'Подробный почасовой график на будущий день доступен после консультации. Свяжитесь с нами через кнопку ниже — обсудим РДН.',
          b2bTomorrowChartGateClose: 'Закрыть',
          b2bTomorrowChartGateBack: 'Назад',
          b2bDayKwhChartLoading: 'Загрузка…',
          b2bDayKwhChartNoData: 'Нет данных за выбранную дату',
          b2bDayKwhChartRateLimited:
            'Превышен лимит запросов. Попробуйте позже (в сутки разрешено ограниченное количество просмотров).',
          b2bDayKwhChartVolumeLabel: 'Объём, кВт·ч',
          b2bDayKwhChartTariffAxisLabel: 'Тариф, грн/кВт·ч',
          b2bDayKwhChartLegend220: 'Объём, кВт·ч (220)',
          b2bDayKwhChartLegendToka: 'Объём, кВт·ч (toka)',
          b2bDayKwhChartLegendTariff: 'Тариф, грн/кВт·ч',
          b2bDayKwhChartLegendDam: 'DAM',
          b2bMarketNameDam: 'DAM',
          b2bMarketNameRdn: 'РДН',
          b2bMarketTariffUnitUahPerKwh: 'грн/кВт·ч',
          b2bDayKwhChartLegendMarketLine: '{{market}}, {{unit}}',
          b2bDayKwhChartTooltipPriceWithUnit: '{{value}} {{unit}}',
          b2bDayKwhChartTooltipHour: 'Час',
          b2bDayKwhChartTooltipVolume: 'Объём',
          b2bDayKwhChartTooltipTariff: 'Тариф',
          b2bDayKwhChartTooltipDam: 'DAM',
          b2bDayKwhChartSeriesEv: 'Зарядки',
          b2bDayKwhChartSeriesDam: 'DAM',
          b2bDayKwhChartSeriesMining: 'Майнинг',
          b2bNoStationsHeader: 'У вас еще нет станций',
          b2bNoStationsBody: 'Свяжитесь с нами для заказа',
          b2bStartBusinessHeader: 'Хотите начать зарядный бизнес?',
          b2bStartBusinessText: 'Это легко, пожалуйста, заполните форму:',
          b2bAddStationHint: 'Хочешь стать частью сети 220?\nНажми ⚡ Присоединиться к 220',
          b2bRealtimePowerLabel: 'Мощность сейчас (МВт)',
          b2bRealtimePowerSessions: '{{count}} заряд. сессий (IN_PROGRESS)',
          b2bRealtimePowerNoActive: 'Нет активной зарядки',
          b2bRegisterStationBtn: 'Зарегистрировать станцию',
          b2bConnectTo220Btn: 'Присоединиться к 220',
          b2bProposeLocationBtn: 'Предложить локацию',
          b2bLookingForLocationBtn: 'Ищу локацию',
          b2bTelegramConnectTo220Greeting: 'Добрый день! Хочу подключиться к 220.',
          b2bTelegramGreeting: 'Я владелец, предлагаю аренду локации',
          b2bTelegramLookingForLocationGreeting: 'Я инвестор, ищу локацию',
          b2bContactUsBtn: 'Связаться с нами',
          b2bLicenseLinkBtn: 'О лицензии на торговлю\nэлектроэнергией',
          b2bConsultRdnBtn: 'Заказать консультацию по РДН',
          b2bGammaPresentationOpen: 'Открыть презентацию на весь экран',
          b2bTelegramConsultRdnGreeting: 'Добрый день! Хочу заказать консультацию по РДН.',
          b2bMessengerChoiceTitle: 'Оставить заявку',
          b2bLeadFormSubmit: 'Отправить',
          b2bLeadFormNameLabel: 'Имя',
          b2bLeadFormNamePlaceholder: 'Введите имя',
          b2bLeadFormPhoneLabel: 'Телефон',
          b2bLeadFormPhonePlaceholder: 'Введите номер телефона',
          b2bLeadFormMessengerHint: 'Отправьте заявку через мессенджер — мы перезвоним.',
          b2bLeadFormPublishHint: 'Опубликуйте заявку на маркетплейсе локаций Вирій ЕМС.',
          b2bLeadFormMarketplaceHint: 'Или опубликуйте заявку без мессенджера',
          b2bMessengerPublishMarketplace: 'Опубликовать на маркетплейсе Вирій ЕМС',
          b2bMessengerPublishMarketplaceSuccess: 'Заявка отправлена. После модерации она появится на маркетплейсе.',
          b2bMessengerPublishMarketplaceError: 'Не удалось опубликовать на маркетплейсе',
          b2bLeadFormKwLabel: 'Доступная мощность, кВт',
          b2bLeadFormRequired: 'Обязательное поле',
          b2bLeadFormInvalidPhone: 'Укажите корректный номер телефона',
          b2bLeadFormLocationsRequired: 'Добавьте хотя бы одну локацию на карте',
          b2bLeadFormRegionLabel: 'Желаемый регион',
          b2bLeadFormRegionRequired: 'Выберите регион на карте',
          b2bLeadFormRegionRadiusLabel: 'Радиус поиска',
          b2bLeadFormRegionRadiusValue: '{{value}} км',
          b2bLeadFormRegionMapHint: 'Нажмите на карту, чтобы выбрать центр поиска, и задайте радиус вокруг точки.',
          b2bLeadFormRegionMapAria: 'Карта для выбора региона',
          b2bLeadFormMessagePreview: 'Предпросмотр сообщения',
          b2bLeadFormSubmitError: 'Заполните все обязательные поля перед отправкой',
          b2bLeadFormSaveError: 'Не удалось сохранить заявку. Попробуйте ещё раз.',
          b2bLeadFormSentStatus: 'Заявка отправлена. Команда 220 свяжется с вами.',
          b2bLeadFormRateLimit: 'Слишком много заявок из этой сети. Попробуйте позже.',
          b2bLeadFormDistributionLabel: 'Договор с облэнерго',
          b2bLeadFormYes: 'Да',
          b2bLeadFormNo: 'Нет',
          b2bLeadFormLocationsLabel: 'Локации на карте',
          b2bLeadFormMapHint:
            'Нажмите на карту, чтобы добавить локацию. Можно выбрать несколько точек. Кнопка «Моё местоположение» только центрирует карту.',
          b2bLeadFormMapAria: 'Карта для выбора локаций',
          b2bLeadFormMapGeolocate: 'Моё местоположение',
          b2bLeadFormMapLoading: 'Загрузка…',
          b2bLeadFormMapRemove: 'Удалить',
          b2bLeadFormParkingPhotosLabel: 'Фото парковки (необязательно)',
          b2bLeadFormConnectionPhotosLabel: 'Фото точки присоединения (необязательно)',
          b2bMarketplaceMapConnectionPhotos: 'Фото точки присоединения',
          b2bMarketplaceMapParkingPhotos: 'Парковка',
          b2bMarketplaceMapKw: 'Мощность, {{value}} кВт',
          b2bLeadFormDistributionContractPhotosLabel: 'Фото договора на распределение (необязательно)',
          b2bLeadFormDistanceLabel: 'Расстояние до точки присоединения, м',
          b2bLeadFormDistancePlaceholder: 'Выберите расстояние',
          b2bLeadFormDistanceUpTo5: 'до 5 м',
          b2bLeadFormPriceKwhExtraLabel: 'Доплата за кВт·ч',
          b2bLeadFormMonthlyParkingLabel: 'Месячная цена за парковочное место',
          b2bMarketplaceTitle: 'Сохранённые локации',
          b2bMarketplaceSubtitle: 'Опубликованные предложения локаций без контактных данных',
          b2bMarketplaceMapHint: 'Нажмите маркер на карте, чтобы посмотреть детали локации',
          b2bMarketplaceEmpty: 'Пока нет опубликованных локаций',
          b2bMarketplaceLoadError: 'Не удалось загрузить локации',
          b2bMarketplaceMapAria: 'Карта сохранённых локаций',
          b2bMarketplaceDetailTitle: 'Детали локации',
          b2bMarketplacePublishedOn: 'Опубликовано {{timeAgo}}',
          b2bMarketplaceRequestInfo: 'Запросить информацию',
          b2bMarketplaceOwnerInfoTitle: 'Контакты владельца локации',
          b2bMarketplaceOwnerName: 'Имя',
          b2bMarketplaceOwnerPhone: 'Телефон',
          b2bMarketplaceDistributionContractPhotosLabel: 'Фото договора на распределение',
          b2bMarketplacePayFailed: 'Не удалось оплатить доступ к информации',
          b2bMarketplacePayProcessing: 'Оплата ещё обрабатывается. Попробуйте обновить страницу через минуту.',
          b2bMarketplacePayTestSkip: 'Пропустить оплату (local test)',
          b2bMarketplaceViewedTimes: 'Просмотрено {{count}} раз',
          b2bMarketplaceContactTitle: 'Связаться по этой локации',
          b2bMarketplaceContactGreeting: 'Здравствуйте! Интересует локация из маркетплейса Вирій ЕМС.',
          b2bMarketplaceListingId: 'ID заявки',
          b2bMarketplaceClose: 'Закрыть',
          b2bMarketplaceHeatmapLegendTitle: 'Спрос на зарядку',
          b2bMarketplaceHeatmapLegendLow: 'меньше',
          b2bMarketplaceHeatmapLegendHigh: 'больше',
          b2bAccordionLocationMarketplace: 'Маркетплейс локаций',
          b2bMarketplaceShareBtn: 'Поделиться',
          b2bMarketplaceShareCopied: 'Ссылка скопирована',
          b2bMarketplaceShareText: 'Маркетплейс локаций Вирій ЕМС',
          b2bSectionShareQrAlt: 'QR-код ссылки на раздел B2B',
          b2bSectionShareCopyLink: 'Скопировать ссылку',
          b2bSectionShareOpenLink: 'Открыть ссылку',
          b2bAccordionTariffs: 'Тарифы на подключение ЭЗС',
          b2bTariffsShareText: 'Тарифы на подключение ЭЗС 220-km',
          b2bAccordionServiceRequest: 'Заявка на сервис',
          b2bServiceRequestShareText: 'Прайс сервисных услуг 220-km',
          b2bServiceRequestOrderBtn: 'Заказать сервис',
          b2bServiceRequestGreeting: 'Добрый день! Хочу заказать сервис зарядных станций.',
          b2bAccordionDayAhead: 'РДН + накопление энергии',
          b2bDayAheadShareText: 'РДН + накопление энергии 220-km',
          b2bAccordionCaseBenny: 'Кейс: роуминг показал +18%',
          b2bCaseBennyShareText: 'Кейс 220-km: роуминг показал +18% на Benny 360 кВт',
          b2bAccordionCaseBakery: 'Кейс: пекарня, батарея до конца цикла',
          b2bCaseBakeryShareText: 'Кейс 220-km: пекарня и заряд батареи',
          b2bAccordionCaseSolar: 'Кейс: солнце, динамический тариф',
          b2bCaseSolarShareText: 'Кейс 220-km: солнце и динамический тариф',
          b2bMessengerTelegram: 'Telegram',
          b2bMessengerWhatsApp: 'WhatsApp',
          b2bNewCabinetBtn: 'B2B кабинет Pro (beta)',
          b2bFlowGraphTitle: 'Диаграмма потока энергии',
          b2bFlowGraphSolar: 'Солнце',
          b2bFlowGraphWind: 'Ветер',
          b2bFlowGraphWindShareAria: 'Sirocco Energy — QR-код и ссылка',
          b2bFlowGraphWindShareTitle: 'Sirocco Energy',
          b2bFlowGraphWindShareSubtitle: 'Отсканируйте QR-код или скопируйте ссылку на документацию ветровой турбины',
          b2bFlowGraphWindShareQrAlt: 'QR-код ссылки на Sirocco Energy',
          b2bFlowGraphESS: 'УЗЕ',
          b2bFlowGraphEssVendorsTitle: 'Совместимые бренды УЗЕ',
          b2bFlowGraphEssVendorsAria: 'Показать логотипы производителей',
          b2bFlowGraphEssVendorShareCardAria: '{{vendor}} — QR-код и ссылка на сайт производителя',
          b2bFlowGraphEssVendorShareTitle: '{{vendor}}',
          b2bFlowGraphEssVendorShareTitleFallback: 'Совместимые бренды УЗЕ',
          b2bFlowGraphEssVendorShareSubtitle: 'Отсканируйте QR-код или скопируйте ссылку на сайт производителя',
          b2bFlowGraphEssVendorShareQrAlt: 'QR-код ссылки на сайт {{vendor}}',
          b2bFlowGraphEssVendorOpensExternal: 'сайт производителя, новая вкладка',
          b2bFlowGraphEssCertificateCardAria: '{{vendor}} — сертификат официального сервисного центра',
          b2bFlowGraphEssCertificateModalTitle: 'Сертификат официального авторизованного сервисного центра',
          b2bFlowGraphEssCertificateImageAlt: 'Сертификат официального сервисного центра {{vendor}}',
          b2bFlowGraphInverter: 'Инвертор',
          b2bFlowGraphEmsVpp: 'EMS + VPP',
          b2bFlowGraphEmsLinkText: 'EMS',
          b2bFlowGraphEmsVppSuffix: ' + VPP',
          b2bFlowGraphHubOpenEmsAria: '220-km.com — Open EMS, интерфейс потока энергии EMS + VPP (новая вкладка)',
          b2bFlowGraphGrid: 'Сеть',
          b2bFlowGraphCharging: 'EV Зарядка',
          b2bFlowGraphMiner: 'Майнер',
          b2bFlowGraphMinerShareAria: 'Binance Pool — QR-код и ссылка',
          b2bFlowGraphMinerShareTitle: 'Binance Pool',
          b2bFlowGraphMinerShareSubtitle: 'Отсканируйте QR-код или скопируйте ссылку на статистику майнера',
          b2bFlowGraphMinerShareQrAlt: 'QR-код ссылки на Binance Pool',
          b2bFlowGraphESSCharging: 'Зарядка',
          b2bFlowGraphESSDischarging: 'Разрядка',
          b2bFlowGraphGridSelling: 'Продажа',
          b2bFlowGraphExpandWide: 'Развернуть диаграмму (широкий экран)',
          b2bFlowGraphCloseWide: 'Вернуться на страницу',
          b2bFlowGraphUnitKw: 'кВт',
          b2bFlowGraphUnitMw: 'МВт',
          b2bRevenue: 'Выручка',
          b2bEnergy: 'Энергия',
          b2bAverageRate: 'Тариф',
          b2bDeposit: 'Депозит',
          b2bTariffs: {
            title: 'Тарифы на подключение ЭЗС',
            features: 'Возможности',
            tariffBase: 'Тариф Базовый 5%',
            tariffBaseName: 'Тариф Базовый',
            tariffBaseRate: '5%',
            tariffPro: 'Тариф Про 7%',
            tariffProName: 'Тариф Про',
            tariffProRate: '7%',
            tariffProPlus: 'Тариф Про+ 9%',
            tariffProPlusName: 'Тариф Про+',
            tariffProPlusEmsLabel: 'интеграция с',
            tariffProPlusEmsName: 'Вирій EMS',
            tariffProPlusRate: '9%',
            feature1: 'Бизнес кабинет',
            feature2: 'Общий телеграм бот службы поддержки',
            feature3: 'Выплаты раз в день на счёт ФОП монобанк',
            feature4: 'Обновление статуса раз в 30 секунд',
            feature15: 'Возможность настраивать индивидуальные и групповые тарифы',
            feature5: 'Возможность подключать бюджетные китайские станции',
            feature6: 'Бесплатная настройка станции под ключ',
            feature7: 'Бесплатные наклейки и мобильная связь',
            feature8: 'Камера для VIP сервиса для ваших водителей',
            feature9: 'Отдельная телеграм группа поддержки + камера + фото статистика',
            feature11: 'Обновление статуса раз в 5 секунд',
            feature12: 'Возможность подключить роуминг',
            feature13: 'Возможность получать выплаты на любой счёт украинского банка',
            feature14: 'Бронирование порта для водителей',
            feature16: 'Приоритетное решение сервисных вопросов',
            feature18: 'Динамический тариф от SoC батареи или РДН',
            feature19: 'Интеграция с Вирій EMS',
            feature20: 'Возможность создавать топливные карты',
          },
          months: {
            january: 'Январь',
            february: 'Февраль',
            march: 'Март',
            april: 'Апрель',
            may: 'Май',
            june: 'Июнь',
            july: 'Июль',
            august: 'Август',
            september: 'Сентябрь',
            october: 'Октябрь',
            november: 'Ноябрь',
            december: 'Декабрь',
          },
          monthsShort: {
            january: 'Янв',
            february: 'Фев',
            march: 'Мар',
            april: 'Апр',
            may: 'Май',
            june: 'Июн',
            july: 'Июл',
            august: 'Авг',
            september: 'Сен',
            october: 'Окт',
            november: 'Ноя',
            december: 'Дек',
          },
          teslaAdapterNotification: {
            title: 'Инструкция для американских авто с адаптером.',
            message: 'Если вы используете адаптер с кнопкой, пожалуйста, нажмите её один раз сейчас!',
            button: 'Понятно',
          },
          streetView: {
            title: 'Открыть 3D просмотр?',
            yes: 'Да',
            no: 'Нет',
          },
          map: {
            distanceFromYou: '{{km}} км от вас',
            todayStatsTitle: 'Сегодня:',
            todayDriven: 'Пройдено: {{km}} км',
            todaySpent: 'Потрачено: {{uah}} uah',
            todayDrivenCompact: '{{km}} км',
            todaySpentCompact: '{{uah}} uah',
            todaySpentPerKm: '{{value}} uah/км',
            speedCameraAhead: 'Камера впереди: {{meters}} м',
            speedLimit: 'Лимит: {{limit}} км/ч',
            warningAt: 'Предупреждение на: {{threshold}} км/ч',
          },
          locationRequired: {
            title: 'Требуется доступ к геолокации',
            description:
              'Для просмотра списка станций необходимо разрешить доступ к вашему местоположению. Это поможет показать ближайшие станции.',
            retry: 'Разрешить геолокацию',
            goToMap: 'Перейти к карте',
          },
          freeTestCharge: {
            title: 'Попробуйте бесплатно!',
            description: 'Мы дарим Вам первую зарядку бесплатно, чтобы убедиться, что всё работает!',
            yesButton: 'Да, начать бесплатно!',
            noButton: 'Нет, я оплачу сам',
          },
          quickStart: {
            button: 'Cтарт',
            headline: 'Вас приветствует Сеть 220!',
            intro: 'Подключите автомобиль и нажмите «Старт».',
            afterSessionHint: 'После остановки тестовой сессии появится кнопка «Оплатить».',
            description: 'Протестируйте, что станция зарядки работает с вашим электромобилем',
            defaultText: 'Вас приветствует Сеть 220!',
          },
          reservation: {
            reserveButton: 'Забронировать ({{minutes}} мин)',
            btnReserve: 'Забронировать',
            btnReserveCooldown: 'Забронировать {{time}}',
            reservedByYou: 'Порт забронирован вами',
            reservedByOther: 'Порт забронирован другим водителем',
            countdown: 'Осталось: {{time}}',
            cancel: 'Отменить бронирование',
            dailyLimitExceeded: 'Лимит: только 1 бронирование в сутки',
            portAlreadyReserved: 'Порт уже забронирован другим водителем',
            notAllowed: 'Бронирование на этом порту выключено',
            portBusy: 'Порт сейчас заряжается, попробуйте позже',
            postJobCooldown: 'Бронирование доступно через 10 минут после завершения предыдущей зарядки',
            nativeAppRequired: 'Бронирование доступно только в приложении 220',
            notEligible: 'Бронирование доступно только в приложении 220',
            webInstallAppPopup: 'Чтобы пользоваться бронированием, установите приложение',
            webInstallAppBtn: 'Установить приложение',
            failed: 'Не удалось забронировать порт',
            detailsTitle: 'Бронирование',
            detailsPort: 'Порт #{{port}}',
            detailsDuration: '{{minutes}} мин',
            detailsDistance: '{{distance}} км от вас',
            detailsDistanceUnknown: 'Расстояние неизвестно',
            detailsAttemptsLoading: '…',
            detailsAttempts: 'Бронирований сегодня: {{used}}/{{max}}',
            detailsConfirm: 'Забронировать',
            detailsCancel: 'Отмена',
            tooFar: 'Бронирование доступно только в пределах {{maxKm}} км от станции',
            locationRequired: 'Включите геолокацию на карте, чтобы забронировать порт',
          },
          restartStation: {
            button: 'Перезапустить станцию',
            confirmOcpp: 'Перезапустить ПОРТ # {{port}}?\n\n(ID устройства скопирован в буфер обмена)',
            confirmToka: 'Перезапустить зарядную станцию TOKA?',
            successOcpp: 'Команда перезапуска отправлена.',
            successToka: 'Станция перезапущена. Команда отправлена.',
            errorFailed: 'Не удалось перезапустить станцию. Попробуйте позже.',
          },
          dcChargingLoader: {
            starting: 'Запускаем зарядку',
            title: 'Зарядка не началась?',
            lead: 'Всё ОК, пожалуйста:',
            steps:
              'достаньте коннектор из машины > отъедьте 10 метров > закройте все двери > и запустите зарядку ещё раз.',
          },
          freeChargeError: {
            title: 'Ошибка',
            message: 'Слишком много попыток бесплатной зарядки',
          },
          rateLimitError: {
            title: 'Лимит превышен',
            message: 'Слишком много запросов. Попробуйте позже.',
          },
          nativeAppFreeChargeError: {
            title: 'Недоступно в приложении',
            message:
              'Бесплатный быстрый старт в мобильном приложении недоступен. Пополните баланс на сайте 220-km.com или выберите платную зарядку ниже.',
          },
          deployMaintenanceTitle: 'Все в порядке, мы обновляем сайт.',
          deployMaintenanceWait: 'Подождите ~30 секунд.',
          ...(portNotes.ru ? portNotes.ru : {}),
        },
      },
      en: {
        translation: {
          slider: {
            kWhFor: 'kWh',
            aboutKm: 'about',
          },
          forKwh: 'for',
          energy: 'kWh',
          energyKwh: 'kWh',
          btns: {
            start: ' hours',
            startKwt: ' kWh',
            startFree: 'Try for free',
            startFullCharge: 'Just Start',
            getAllStationsStatus: 'Show all stations',
            getNearestStationsStatus: 'Show other stations',
          },
          historyEmpty: 'Charging history is empty',
          showPwaInstruction: 'Install App',
          installApp: 'Install App',
          installAppText: '220 app does not require free space on your phone.',
          installAppTextSecond: 'To install app click on instruction:',
          installAppTextThird: 'After 220 app is installed, please use QR scanner from app only.',
          installAppAttention: 'Attention!',
          installAppButton: 'Install App',
          installAppQrSectionLabel: 'QR codes to install the app',
          installAppQrIosTitle: 'iOS',
          installAppQrIosSubtitle: 'App Store',
          installAppQrIosAlt: 'QR code to install from App Store',
          installAppQrPlayTitle: 'Android',
          installAppQrPlaySubtitle: 'Google Play',
          installAppQrPlayAlt: 'QR code to install from Google Play',
          installAppQrAndroidTitle: 'Android',
          installAppQrAndroidSubtitle: 'Download APK',
          installAppQrAndroidAlt: 'QR code to download APK',
          title: 'Charge 220 kilometers overnight',
          station: 'Port # ',
          feedbacks: 'Feedbacks',
          leaveFeedback: 'Leave a feedback',
          feedback: {
            leave: 'Leave Feedback',
            title: 'Leave Feedback',
            textLabel: 'Your feedback',
            textPlaceholder: 'Tell us about your experience at this station…',
            ratingLabel: 'Rating',
            maxKwLabel: 'Car max power',
            maxKwHint: 'kW',
            kwUnit: 'kW',
            carPhotoLabel: 'Photo of your car at the station',
            choosePhoto: 'Choose photo',
            required: 'required',
            optional: 'optional',
            photoRequiredNear: 'You are near the station — please add a photo of your car.',
            removePhoto: 'Remove photo',
            locating: 'Getting your location…',
            submit: 'Submit',
            successTitle: 'Thank you!',
            successBody: 'Your feedback was sent.',
            askPromptTitle: 'Leave feedback?',
            askPromptBody: 'Tell us about this station.',
            askPromptLeave: 'Leave feedback',
            askPromptClose: 'Close',
            askPromptDontAsk: "Don't ask for 30 days",
            listTitle: 'Feedback',
            teamLabel: 'Reply from the 220 team',
            empty: 'No feedback yet',
            compose: 'Write feedback',
            avgAria: 'Average rating {{rating}}',
            reviewsCount: '{{count}} reviews',
            prev: 'Back',
            next: 'Next',
            pageOf: '{{page}} / {{pages}}',
            carPower: '{{kw}} kW',
            errors: {
              rateLimited: 'You can leave at most 2 reviews per day.',
              paymentRequired: 'You can leave feedback after a successful payment at this station.',
              photoRequired: 'Please add a photo of your car at the station.',
              tooLarge: 'File is too large. Try another photo.',
              generic: 'Could not send feedback. Please try again.',
            },
          },
          serviceRequestForm: {
            title: 'Service request',
            problemTypesLabel: 'Problem type',
            problemTypes: {
              port_not_working: 'Charging port not working',
              station_offline: 'Station offline / not responding',
              cable_damage: 'Cable / connector damage',
              payment: 'Payment problem',
              other: 'Other',
            },
            portLabel: 'Port number',
            cityLabel: 'City',
            cityPlaceholder: 'Station city',
            descriptionLabel: 'Problem description',
            descriptionPlaceholder: 'Describe what happened…',
            descriptionHint: 'Include car brand/model/year, connector type and adapter if any.',
            phoneLabel: 'Phone',
            phonePlaceholder: '+380…',
            photosLabel: 'Required photos',
            photoSlots: {
              car_port: 'Car port / adapter photo + VIN',
              car: 'Car photo',
              station: 'Station number / screen error photo',
            },
            removePhoto: 'Remove photo',
            optional: 'optional',
            submit: 'Submit',
            successTitle: 'Request sent',
            successBody: 'We will contact you shortly.',
            listTitle: 'Service requests',
            empty: 'No requests yet',
            compose: 'New request',
            errors: {
              rateLimited: 'You can send at most 2 service requests per day.',
              problemRequired: 'Choose a problem type.',
              portRequired: 'Enter the port number.',
              descriptionRequired: 'Describe the problem, at least 5 characters.',
              phoneRequired: 'Enter a phone number.',
              invalidPhone: 'Please check the phone number.',
              photoRequired: 'Add this photo.',
              tooLarge: 'Files are too large. Try other photos.',
              photosRequired: 'Please add a photo of the car.',
              generic: 'Could not send the request. Please try again.',
            },
          },
          refundForm: {
            title: 'Refund request',
            portLabel: 'Port number',
            portPlaceholder: 'PORT # on the station or 220-km.com',
            fullNameLabel: 'Full name',
            fullNamePlaceholder: 'First and last name',
            reasonLabel: 'Reason type',
            problemTypesLabel: 'Select the problem type you faced (you can choose several)',
            problemTypesPlaceholder: 'Select a problem type',
            problemTypes: {
              port_not_working: 'Charging port not working',
              station_offline: 'Station not responding / offline',
              cable_damage: 'Cable / connector damage',
              payment: 'Payment problem',
              other: "Other (describe in the 'Reason description' field)",
            },
            phoneLabel: 'Phone number',
            phonePlaceholder: '+380…',
            descriptionLabel: 'Refund reason description',
            descriptionPlaceholder: 'Describe what happened…',
            descriptionHint:
              'For a failed charge, include car brand/model/year, connector type and adapter (with or without button for Tesla).',
            cardLabel: 'Card number for refund',
            cardPlaceholder: '16 digits',
            amountLabel: 'Refund amount (UAH)',
            amountPlaceholder: '0.00',
            contactedLabel: 'Did you call 220 support by phone?',
            yes: 'Yes',
            no: 'No',
            ratingLabel: 'Charging process rating',
            photosLabel: 'Required photos',
            photoSlots: {
              receipt: 'Bank payment receipt',
              car: 'Car / port / error screen photo',
            },
            removePhoto: 'Remove photo',
            optional: 'optional',
            submit: 'Submit request',
            successTitle: 'Request sent',
            successBody: 'We will review the payment and refund to your card.',
            manualHint: 'New phone or no session in history — fill in all fields below.',
            termsSummary: 'Card refunds are governed by the <termsLink>public offer (clauses 7.3–7.4)</termsLink>.',
            terms73:
              'The Aggregator reviews the request. Review may take up to 60 working days depending on the User’s bank. The Aggregator aims to process requests sooner. If refunded funds were already credited to the Contractor, the Aggregator may withhold that amount from later settlements with the Contractor.',
            terms74:
              'In the request, provide a phone number and reason. The session is linked automatically via the payment invoice.',
            recoverAlternative:
              'Faster alternative: recover virtual balance from a bank receipt — you can use it immediately for the next charge.',
            noSessionBody: 'No session available for a refund. Contact support with the port number and bank receipt.',
            button: 'Refund',
            errors: {
              incomplete: 'Fill in the required fields',
              portRequired: 'Enter the port number',
              nameRequired: 'Enter your full name',
              phoneRequired: 'Enter your phone number',
              phoneInvalid: 'Check the phone number',
              reasonRequired: 'Select a problem type',
              descriptionRequired: 'Describe the reason (min. 10 characters)',
              cardRequired: 'Enter the card number (13–19 digits)',
              amountRequired: 'Enter the amount in UAH',
              contactedRequired: 'Say whether you contacted support',
              ratingRequired: 'Rate the charging process (1–5)',
              receiptPhotoRequired: 'Add the bank receipt photo',
              carPhotoRequired: 'Add the car / port / error photo',
              rateLimited: 'You can send at most 2 refund requests per day.',
              invalidPhone: 'Please check the phone number.',
              duplicate: 'A refund request for this payment was already sent.',
              tooLarge: 'File is too large. Try another photo.',
              generic: 'Could not send the request. Please try again.',
            },
          },
          chargeLink: 'Charging',
          landingLink: 'All stations',
          landingLinkMap: 'Map',
          contacts: 'Contact us',
          buyUps: 'Buy UPS',
          chooseVolume: 'Change',
          history: 'History',
          offer: 'Offer',
          offerTitle: 'Public Offer Agreement',
          terms: {
            tabs: {
              driver: 'For Drivers',
              stationOwner: 'For Station Owners',
            },
            stationOwnerTitle: 'Public Offer Agreement for Charging Station Owners in the 220-km.com Network',
            stationOwnerIntro:
              'This document sets the cooperation terms between the Customer (station owner) and individual entrepreneur Pavlov Maksym Valeriiovych for access to the 220-km.com Bank API.',
          },
          b2bContract: {
            tariffsLinkIntro: 'Detailed tariffs and features are available on',
            tariffsLinkLabel: '220-km.com/b2b',
          },
          wt: 'kWh',
          powerWt: ' kW',
          maxPower: 'max power',
          maxPowerSticker: 'max {{kw}} kW',
          maxPowerStickerAria: 'Maximum power {{kw}} kW',
          maxPowerStickerRangeAria: 'Power {{minKw}}–{{maxKw}} kW',
          portPriceStickerAria: 'Rate {{price}} {{unit}} per kWh',
          portPriceStickerScheduleAria: 'Rate {{price}} {{unit}} per kWh, show dynamic tariff schedule',
          portPriceStickerUnit: 'uah',
          plugTypeNoCable: 'no cable',
          dynamicTariffScheduleTitle: 'Dynamic tariff',
          portCardOpenStartManyAria: 'Open all ports on this device, port {{stationNumber}}',
          powerKwh: ' kWh',
          balance: 'Balance:',
          balanceNe: 'un',
          balanceWord: 'balance:',
          energyCard: {
            label: 'energy card',
            kwhForPorts: 'kWh for charging on ports',
            uahForPorts: 'UAH for charging on ports',
            chargeWithEc: 'Charge with Fuel Card',
            validUntil: 'valid until',
            brandedName: 'Fuel card for {{kwh}} kWh from 220-km.com',
            brandedNameUah: 'Fuel card for {{uah}} UAH from 220-km.com',
            cardId: 'Card ID',
            archived: 'Archived cards',
            usedKwh: 'used',
            leftKwh: 'left',
            usedLeftLabel: '{{used}} / {{left}} kWh',
            usedLeftLabelUah: '{{used}} / {{left}} UAH',
            chargingOnPort: 'charging on port #{{port}}',
            clickPortForDetails: 'Click a port number to show details',
            remainingUahHint: '{{uah}} UAH left',
          },
          currency: ' uah',
          portraitOnlyMessage: 'Please rotate your device vertically',
          portraitOnlyHint: 'This app works in portrait mode only',
          payedForKwh: 'Paid',
          spent: 'Spent',
          v: 'V',
          km: ' km',
          approximately: 'about',
          chargedCongrats: 'Congrats!!!',
          chargedkWt: 'Your car has been charged by: ',
          startNew: 'Go again',
          stationStoppedCharging: 'Station stopped charging: {{detail}}',
          power: 'Power',
          powerExceededError: 'Please reduce power and try again:',
          onlineStatus: 'Offline',
          powerKm: 'km/h',
          charging: 'Charged',
          openPowerHistoryChart: 'Open power history chart',
          powerCurveSessionOnly: 'Power curve available only for your session',
          voltage: 'Voltage',
          chargingSpeed: 'Charging speed',
          solar: 'Solar',
          bess: 'BESS',
          bessReserveSource: 'Backup power',
          stationAdditionalSourceBess: 'This station has backup power',
          batteryDischarge: 'Battery',
          batteryCharging: 'charging',
          openEmsInverterLinkAria: 'Open Open EMS for {{kwh}} kWh inverter',
          renewable: 'green energy',
          batterySocPct: 'SoC {{pct}}%',
          solarInsolationTomorrowLine: 'Tomorrow {{pct}}%',
          solarInsolationToday: 'Today',
          solarInsolationTomorrow: 'Tomorrow',
          solarInsolationForecast: 'Insolation today and tomorrow',
          solarInsolationDayGraphAria: 'Hourly insolation forecast for today at the port location',
          solarInsolationTomorrowGraphAria: 'Hourly insolation forecast for tomorrow at the port location',

          allStationsStatusUnavailable: 'Unavailable now',
          getBloodyLitersSaved: 'Reincarnated',
          bloodyLitersLink: 'https://youtu.be/mk-LnUYEXuM?si=BFE0nuqLCCcU5P6o&t=95',
          noNearestStations: 'No stations found near you',
          showing: 'Showing',
          of: 'of',
          stations: 'stations',
          performanceMode: 'Performance Mode',
          fallbackMode: 'fallback mode',
          loadingMore: 'Loading next',
          scrollToLoadMore: 'Scroll to load more',
          loadMoreStations: 'Load more stations',
          getDirection: 'Get direction',
          route: 'Navigate',
          outageSchedule: {
            button: 'Outage schedule',
            title: 'Outage schedule',
            loading: 'Requesting the schedule…',
            group: 'Group {{group}}',
            today: 'Today',
            tomorrow: 'Tomorrow',
            noOutages: 'No planned outages',
            waiting: 'The schedule is not published yet',
            emergency: 'Emergency outages',
            updated: 'Updated {{time}}',
            allGroups: 'Same for every group',
            queuesHint: 'Street was not recognized. Choose a group:',
            chooseGroup: 'Choose a group:',
            anotherGroup: 'Another group',
            unsupported: 'There is no schedule for this region.',
            groupUnknown: 'The schedule is published by queue. GPS does not identify the queue.',
            notFound: 'Could not match a building to the port coordinates.',
            error: 'Could not load the schedule. Try again.',
          },
          photo: 'Photo',
          distanceKm: ' km',
          distanceM: 'm',
          locationError: 'Please enable location access in your browser settings.',
          mapFarGpsAirAlert: 'Air alert in your region, please find the nearest shelter.',
          mapFarGpsAirAlertDismiss: 'OK',
          toHomePage: 'All stations',
          allStations80Plus: 'All Fast Stations',
          allStationsEvboost: 'All Stations',
          recoverBalance: 'Recover Balance',
          recoverBalanceAutomatically: 'Recover balance',
          recoverBalanceUploadHint:
            'Upload a payment screenshot from your bank (monobank, PrivatBank, etc.). The UAH amount will be recognized automatically.',
          recoverBalanceSelectFile: 'Upload screenshot',
          recoverBalanceSubmit: 'Recover',
          recoverBalanceManualFallback: 'Submit manual request',
          recoverBalanceError: {
            PARSE_FAILED: 'Could not recognize amount from photo. Try a clearer screenshot.',
            ORDER_NOT_FOUND: 'No order found with this amount. Please check the receipt.',
            ALREADY_RECOVERED: "You can't recover the same receipt many times.",
            NO_IMAGE: 'Please select a receipt screenshot.',
            RATE_LIMITED: 'Too many attempts. Please try again tomorrow.',
            NATIVE_APP_REQUIRED: 'Balance recovery is available only in the 220 app.',
            UNKNOWN: 'Error. Please try again later.',
          },
          serviceRequest: 'Service Request',
          notifyWhenOnline: 'Notify when online',
          notifyWhenFinish: 'Notify when finish',
          freshPorts: 'New Online',
          online: 'Online',
          offline: 'Offline',
          seconds: 'secs',
          minutes: 'mins',
          hours: 'hours',
          days: 'days',
          allCars: 'Cars From China',
          china: 'Cars From China',
          allPorts: 'All Ports',
          onlyFast: 'Fast Chargers',
          filter80Kw: '+ Roaming',
          filter160Kw: '160+ kW',
          filterFast: 'Fast',
          filterSlow: 'Slow',
          filterChina: 'China ports',
          filterNacs: 'NACS',
          filterCheapest: 'Cheapest',
          filterEuropean: 'Europe & America',
          filterOnline: 'Online',
          єСвітло: 'Online',
          mapPortSearchPlaceholder: 'Port #',
          mapPortSearchNoResults: 'No port found',
          mapPortSearchLoading: 'Searching…',
          mapPortSearchRoute: 'Route',
          openMapsTitle: 'Open route',
          openMapsInWaze: 'Navigate in Waze',
          openMapsInGoogle: 'Navigate in Google',
          openMapsInEvua: 'Open in EV UA',
          openMapsEvuaDetailsLoading: 'Loading details…',
          openMapsEvuaDetailsEmpty: 'Station details unavailable',
          openMapsEvuaOperator: 'Operator',
          openMapsEvuaProvider: 'Provider',
          openMapsEvuaVendor: 'Vendor',
          openMapsEvuaConnectors: 'Connectors',
          openMapsEvuaPrice: 'Price',
          openMapsEvuaPriceValue: '{{price}} UAH/kWh',
          openMapsEvuaPower: 'Power',
          openMapsEvuaPowerValue: '{{power}} kW',
          openMapsEvuaStationId: 'ID',
          openMapsEvuaCoords: 'Coordinates',
          stationListSearchPlaceholder: 'Search',
          stationListSearchNoResults: 'No stations match your search',
          listOpenEmsEvPowerTitle: 'EV charging',
          listOpenEmsEvPowerTariff: '{{value}} UAH/kWh',
          listOpenEmsEvPowerSessions: '{{count}} active sessions',
          listOpenEmsEvPowerAria: 'Total EV charging power from Open EMS',
          listOpenEmsGreenEnergyAria: 'Total green energy share of the charging network from Open EMS',
          listOpenEmsBannerAria: 'Green energy, total charging power and active sessions from Open EMS',
          startPageShareBtn: 'Share port',
          startPageShareTitle: 'PORT #{{port}}',
          startPageShareText: '220-km charging station — port #{{port}}',
          startPageShareQrAlt: 'QR code for port link',
          startPageShareStickerPreviewAlt: 'PNG sticker preview for port #{{port}}',
          startPageSharePortTypeWithPower: 'Connector: {{type}} · {{kw}} kW',
          startPageSharePortTypeOnly: 'Connector: {{type}}',
          startPageSharePortPowerOnly: 'Power: {{kw}} kW',
          startPageShareStickerPortLabel: 'PORT # ',
          startPageShareStickerDownload: 'Download PNG sticker',
          startPageShareStickerDownloading: 'Preparing PNG…',
          startPageShareStickerError: 'Could not create PNG sticker',
          startPageSharePrintOrder: 'Order print: @kpiprint1',

          login: 'Log In with Google',
          loginTitle: 'Welcome',
          loginText: 'Log in to continue',

          logout: 'Log out',

          historyPage: {
            station: 'PORT #',
            openPort: 'Open PORT #',
            amountS: 'Duration',
            avgPower: 'Avg. power',
            price: 'Paid',
            spendEnergy: 'Spend energy',
            finished: 'Finished',
            refund: 'Refunded',
            bankRefund: 'Refunded to card',
            bankRefundStatus: 'Card refund',
            bankRefundSuccess: 'Refunded',
            balance: 'Balance',
            state: 'Status',
            timeHours: 'h',
            timeMinutes: 'm',
            receipt: 'Receipt',
            loading: 'Loading...',
            receiptError: 'Error loading receipt',
            clientUiId: 'Client UI ID',
            copyClientId: 'Copy client id',
            copiedToClipboard: 'Copied to clipboard!',
            clientOs: 'Operating System',
            clientIdQrTitle: 'Want to share balance and history with a friend or family?',
            clientIdQrSubtitle: "Just scan it from your friend's phone!",
            clientIdQrAlt: 'Client QR code',
            toggleClientIdQr: 'Show client QR',
            createFamily: 'Grant balance access',
            scanClientIdQr: "Scan your friend's QR code",
            loadClientIdQrFromPhoto: 'Import QR code photo',
            loadClientIdQrFromPhotoError: 'Could not read a QR code from this photo. Try another screenshot.',
            powerCurve: 'Power curve',
            power: 'Power',
            voltage: 'Voltage',
            soc: 'SOC',
            summaryTimeSpent: 'Time spent',
            summarySocLabel: 'SoC',
            summarySocLine: 'Started {{started}}% + {{charged}}% = {{total}}%',
            summaryAvgPower: 'Avg power',
            summaryPeakPower: 'Peak power',
            min: 'Min',
            max: 'Max',
            avg: 'Avg',
            noPowerData: 'No curve data yet',
            powerCurvePending: 'The chart appears after 10 minutes of charging',
            revenueChartLast6Months: 'Last 6 months',
            revenueChartPrevious6Months: 'Previous 6 months',
            revenueChartMonthAxis: 'Month',
            revenueChartTooltipCharged: 'Charged',
            revenueChartTooltipSpent: 'Spent',
            revenueChartTooltipAvgPower: 'Avg power',
            revenueChartTotalCharged: 'Charged',
            revenueChartLitersUnit: 'L A-95',
            revenueChartSavedCo2: 'CO₂',
            revenueChartCo2Unit: 't',
            revenueChartSummaryAria: 'Totals',
            loadOlderSessions: 'Older sessions',
          },
          kW: 'kW',

          stopButton: 'Stop',
          stopChargingConfirm: {
            title: 'Stop charging?',
            message: 'Charging will be stopped. Continue?',
            cancel: 'Cancel',
            error: 'Failed to stop charging. Please try again.',
          },
          startButton: 'Start',
          refresh: 'Refresh',

          qrScanner: {
            nameButton: 'Scan QR-code',
            backButton: 'Back',
            refresh: 'Refresh',
            cameraPermissionAlert: 'Please allow camera in your browser permissions and reload',
            cameraUnavailable:
              'Camera works only over HTTPS. Open https://localhost:3000/scanner or paste the QR text below.',
            pasteClientIdHint: 'Paste client QR (220km-client-id:...)',
            importClientIdButton: 'Import',
            scanHint: 'Align the QR code inside the center frame',
            scanning: 'Scanning',
            invalidTokaUrl: 'Invalid Toka link',
            tokaNotFound: 'No 220 ports found for this Toka station',
            tokaLookupError: 'Failed to resolve 220 ports for Toka',
            tokaErrorDetail: 'No 220 ports found for Toka station #{{tokaNumber}}. Link: {{url}}',
            tokaInvalidUrlDetail: 'Invalid Toka link: {{url}}',
            clientIdInvalid: 'Client QR could not be recognized',
            energyCardInvalid: 'Energy Card QR could not be recognized',
            energyCardActivateError: 'Failed to activate Energy Card',
            energyCardAlreadyScanned: 'Fuel card already scanned',
            energyCardWebInstallPopup: 'Please install native app and scan from it',
            loadFromPhoto: 'Import QR code photo',
            loadingFromPhoto: 'Reading QR…',
            loadFromPhotoError: 'Could not read a QR code from this photo. Try another screenshot.',
          },

          userInfoName: 'Logged in as',

          errorStart: {
            portConnectedQuestion: 'Did you connect port #{{portNumber}} to your car?',
            ifSoPleaseDo: 'If so, please:',
            alertMessage: 'Disconnect and connect the plug to your car.',
          },

          inServiceWarning: 'This charging port can work not correctly',
          portInServiceSince: 'Port in service since {{date}}',
          portInService: 'Port in service',
          portInRepairForDays: 'In repair for {{daysText}}',

          error: 'Error',
          errorDevHeader: 'Server error.',
          errorDevBody: 'We are reinventing and will be back soon :)',
          errorOfflineHeader: 'Port #<1>{{stationNumber}}</1> is offline :(',
          errorOfflineBody: 'Offline',
          errorOfflineDcEmergencyHint: 'Please check whether the red emergency stop button on the station is released',
          errorPayHeader: 'Payment is unavailable!',
          errorPayBody: 'Sorry! We are reinventing and will be back soon :)',
          paymentNotConfigured: 'Payment Not configured',
          errorStartFailedHeader: 'Oops, something went wrong, please reconnect :(',
          errorStartFailedBody: '',
          errorFingerPrintUndefindHeader: 'Ad block detected',
          errorFingerPrintUndefindBody: 'Please, turn it off and try again',
          errorFingerPrintUnavailableHeader: 'Free charge is unavailable',
          errorFingerPrintUnavailableBody: 'Please pay:)',

          stationOffline: 'Offline',
          noInternetConnection: 'No internet connection',
          serverConnectionChecking: 'Checking connection to server...',
          serverConnectionError: 'No connection to server. Try using mobile internet',
          ipBlockedError: {
            title: 'Access blocked',
            message: 'Your IP {{ip}} is blocked',
          },
          offlineForDays: 'for {{days}} days',

          costPerHour: ' uah per hour',
          costPerKwt: ' uah per kWh',
          costPerKwtAlt: ' uah/kWh',
          costPerKwtH: ' uah per kWh',

          roamingWithToka: 'roaming with toka',

          readyForUse: 'Ready!',
          listPortConnectedToCar: 'Connected to Car',
          listPortAvailable: 'Available',
          ready: 'READY',
          connected: 'CONNECTED',
          inProgress: 'CHARGING',
          selectPort: 'Please select PORT',
          noPortsFound: 'No ports found',
          noPortsSpecified: 'Please specify ports in the URL',
          goToPort: 'Go to PORT',
          startManyRegionUnknown: 'Ukraine',
          startManyRegionTapForStatus: 'Show status: {{status}}',
          startManySheetExpandMap: 'Show map',
          startManySheetCollapseMap: 'Hide map',
          startManySheetHintUp: 'Swipe up for map',
          startManySheetHintDown: 'Swipe down for ports',
          startManyShareBtn: 'Share station',
          startManyShareTitle: '220-km.com station',
          startManyShareText: '220-km.com charging station — ports {{ports}}',
          startManyShareQrAlt: 'QR code for station link',
          startManyMaxPower: 'Max. power',
          startManyPricePerKwh: '{{price}} uah for 1 kWh',

          calibration: 'Calibrate result!',
          enterYourKm: 'Please, enter your km',
          sendKm: 'Calibrate',
          calibratedKm: 'Your result was calibrated successfully',
          btnRepeat: 'Try Again',

          featureInProgress: 'Coming soon :)',

          back: 'Back',
          close: 'Close',
          photoSource: {
            title: 'The QR screenshot is in your photo library',
            library: 'Load from library',
            cancel: 'Cancel',
          },

          delayedStart: 'Charging will begin at <1>{{openFrom}}</1>',
          beforePayInfoKwh: 'Pay for',
          beforePayInfo: 'Leftovers will be collected on your balance.',
          beforeStartInfo: 'Start session for ',
          cancelDelayedStart: 'Cancel',
          delayedInfo: 'Works from <1>{{openFrom}}</1> till <1>{{closedFrom}}</1>',
          leftBeforeStart: 'Will start in:',
          startAt: 'Will start at <1>{{openFrom}}</1>',
          stationCardInfo: 'from <1>{{openFrom}}</1> to <1>{{closedFrom}}</1>',

          callUs: 'Call Us',
          contactUs: 'Contact us',
          instagram: 'Instagram',
          telegram: 'Telegram Bot',
          whatsApp: 'WhatsApp',
          tapCall: 'Tap to call',
          tapChatBot: 'Telegram chat',
          telHlib: 'Hlib',
          telMax: 'Max',
          notFound: 'Page not found',
          btnPay: 'Pay',
          btnPayFor: 'Start',
          guestPay: {
            title: 'Pay in guest mode?',
            yes: 'Yes',
          },
          driverTermsAccept: {
            label: 'I agree to the <termsLink>terms and conditions</termsLink>',
            popupText: 'To continue, agree to the <termsLink>terms and conditions</termsLink>',
            agree: 'Agree',
          },
          overload: {
            waitForLink: 'Wait a second',
            gettingLink: 'Getting payment link',
            btnPay: 'Pay',
            successChecked: 'Success',
            letsCharge: 'Let`s charge it',
            checking: 'is overloaded checking',
            overloadDetected: 'Overload',
            slowdown: 'Please, slow down to',
            repeat: 'and try again',
          },
          footer: {
            part1: 'All rights reserved',
            part2: 'Made by',
            part3: 'with ♥ to Zero Emission Vehicles',
          },

          b2bHeader: 'B2B',
          b2bHeaderNew: 'B2B (beta)',
          microgridHeader: 'Blackout solutions',
          b2bWelcomeTitle: 'Page for charging station owners',
          b2bSeoMetaDescription:
            '220-km.com B2B for charging station owners: stats, tariffs, DAM/IDM (OREE), EMS + VPP energy flow. Open EMS — smart energy management for microgrids (solar, BESS, EV): automated charge/discharge scenarios, electricity arbitrage, ML generation and price forecasts, Modbus/MQTT/OPC UA, island mode. https://github.com/220-organization/open-ems. Real 220-km.com data analysed in IED NAS Ukraine paper on dynamic EV pricing and grid balancing (port 2005, Pivdennoukrainsk, 2025).',
          b2bSeoMetaKeywords:
            'smart energy management system, microgrid EMS, BESS monitoring, solar plant monitoring, ML solar forecast, ML day-ahead price forecast, electricity arbitrage, DAM IDM, active consumer, island mode, Modbus MQTT OPC UA, Open EMS, EMS Ukraine, VPP, OREE, B2B EV charging, 220-km, Deye, Huawei FusionSolar, smart charging, B2B API, IED NAS Ukraine, grid balancing, дешева зарядка, найдешевша зарядка, де зарядитись при вимкненні світла',
          b2bFlowGraphSeoMetaDescription:
            '220-km.com live energy flow: smart EMS for microgrids — solar, BESS, EV charging, DAM/IDM arbitrage, ML forecast. Open EMS (open-source): https://github.com/220-organization/open-ems',
          b2bMarketplaceSeoTitle: 'Where to install a charging station — locations marketplace',
          b2bMarketplaceSeoMetaDescription:
            '220-km.com locations marketplace for charging station owners: find where to install a charging station — a Ukraine-wide EV charging demand heatmap and ready sites for charging hubs with a DSO grid contract. An alternative to OKKO, AYONIT and Ionity networks: pick a spot, agree with the landowner and launch fast EV charging.',
          b2bMarketplaceSeoMetaKeywords:
            'where to install a charging station, charging hubs, EV charging location marketplace, site for charging station, rent space for EV charger, EV charging demand map, OKKO charging stations, AYONIT, Ionity, DSO grid contract, fast EV charging, EV charging investment, charging station business, 220-km',
          b2bWelcomeText: 'Sign in to the 220-km.com cabinet to view statistics and manage your stations.',
          b2bEvDriversCountLabel: 'Number of users:',
          b2bEvDriversCountInMonth: ' in {{month}}',
          b2bMonthJan: 'January',
          b2bMonthFeb: 'February',
          b2bMonthMar: 'March',
          b2bMonthApr: 'April',
          b2bMonthMay: 'May',
          b2bMonthJun: 'June',
          b2bMonthJul: 'July',
          b2bMonthAug: 'August',
          b2bMonthSep: 'September',
          b2bMonthOct: 'October',
          b2bMonthNov: 'November',
          b2bMonthDec: 'December',
          b2bEnterCabinetBtn: 'Enter cabinet',
          b2bTariffsLink: 'Tariffs and features',
          b2bStatsAvgRate7Days: 'Avg rate last 7 days (UAH/kWh)',
          b2bStatsAvgRate30Days: 'Avg rate last 30 days (UAH/kWh)',
          b2bStatsPerDay: 'Per day',
          b2bStatsPerMonth: 'Per month',
          b2bStatsAvgRateForPeriod: 'Avg rate for {{period}} (UAH/kWh)',
          b2bStatsAvgRateLabel: 'Avg rate in 220-km.com roaming network',
          b2bStatsAvgRateLabelFor: 'for',
          b2bStatsAvgRateValueWithUnit: '{{value}} UAH/kWh',
          b2bStatsTrendVsDayBefore: 'vs day before',
          b2bStatsTrendVsMonthBefore: 'vs month before',
          b2bMonthPickerThisMonth: 'This month',
          b2bMonthPickerPrevYear: 'Previous year',
          b2bMonthPickerNextYear: 'Next year',
          b2bOreePriceIndicesTitle: 'Price indices (OREE)',
          b2bOreePriceIndicesOpen: 'Open on oree.com.ua',
          b2bOpenEmsMonthlyRatesTitle: 'Tariff',
          b2bOpenEmsMonthlyRatesSubtitle: 'Average business tariff incl. distribution and VAT',
          b2bOpenEmsMonthlyRatesOpen: 'Open in Open EMS',
          b2bOpenEmsMonthlyRatesUnit: '/kWh',
          b2bOpenEmsMonthlyRatesVsPrev: 'compared with {{month}}',
          b2bOpenEmsMonthlyRatesNoComparison: 'No comparison',
          b2bOpenEmsMonthlyRatesPending: '...',
          b2bDayKwhChartTitle: '220 Hourly Volumes',
          b2bDayKwhChartMarketShare: 'Ukraine Market Share: ~ {{pct}}',
          b2bDayKwhChartDateLabel: 'Date',
          b2bDatePickerToday: 'Today',
          b2bDatePickerPrevMonth: 'Previous month',
          b2bDatePickerNextMonth: 'Next month',
          b2bDatePickerPrevDay: 'Previous day',
          b2bDatePickerNextDay: 'Next day',
          b2bTomorrowChartGateTitle: 'Tomorrow’s data — contact us first',
          b2bTomorrowChartGateBody:
            'Full hourly chart analysis for a future day is available after a consultation. Use the button below to reach us about RDN.',
          b2bTomorrowChartGateClose: 'Close',
          b2bTomorrowChartGateBack: 'Back',
          b2bDayKwhChartLoading: 'Loading…',
          b2bDayKwhChartNoData: 'No data for selected date',
          b2bDayKwhChartRateLimited: 'Rate limit exceeded. Please try again later (limited views per day).',
          b2bDayKwhChartVolumeLabel: 'Volume, kWh',
          b2bDayKwhChartTariffAxisLabel: 'Tariff, UAH/kWh',
          b2bDayKwhChartLegend220: 'Volume, kWh (220)',
          b2bDayKwhChartLegendToka: 'Volume, kWh (toka)',
          b2bDayKwhChartLegendTariff: 'Tariff, UAH/kWh',
          b2bDayKwhChartLegendDam: 'DAM',
          b2bMarketNameDam: 'DAM',
          b2bMarketNameRdn: 'RDN',
          b2bMarketTariffUnitUahPerKwh: 'UAH/kWh',
          b2bDayKwhChartLegendMarketLine: '{{market}}, {{unit}}',
          b2bDayKwhChartTooltipPriceWithUnit: '{{value}} {{unit}}',
          b2bDayKwhChartTooltipHour: 'Hour',
          b2bDayKwhChartTooltipVolume: 'Volume',
          b2bDayKwhChartTooltipTariff: 'Tariff',
          b2bDayKwhChartTooltipDam: 'DAM',
          b2bDayKwhChartSeriesEv: 'EV',
          b2bDayKwhChartSeriesDam: 'DAM',
          b2bDayKwhChartSeriesMining: 'Mining',
          b2bNoStationsHeader: 'No stations are available yet',
          b2bNoStationsBody: 'Contact us to order',
          b2bStartBusinessHeader: 'Do you want to start earning money using EV charging stations?',
          b2bStartBusinessText: "It's easy, please fill the form and register your station:",
          b2bAddStationHint: 'Want to become part of 220 network?\nTap ⚡ Join 220',
          b2bRealtimePowerLabel: 'Realtime power (MW)',
          b2bRealtimePowerSessions: '{{count}} charging session(s) (IN_PROGRESS)',
          b2bRealtimePowerNoActive: 'No active charging',
          b2bRegisterStationBtn: 'Register Station',
          b2bConnectTo220Btn: 'Join 220',
          b2bProposeLocationBtn: 'Propose location',
          b2bLookingForLocationBtn: 'Looking for Location',
          b2bTelegramConnectTo220Greeting: 'Hello! I want to connect to 220.',
          b2bTelegramGreeting: 'I am the owner and offer to rent out a location',
          b2bTelegramLookingForLocationGreeting: 'I am an investor looking for a location',
          b2bContactUsBtn: 'Contact us',
          b2bLicenseLinkBtn: 'About the electricity\ntrading license',
          b2bConsultRdnBtn: 'Order consultation (RDN)',
          b2bGammaPresentationOpen: 'Open presentation fullscreen',
          b2bTelegramConsultRdnGreeting: 'Hello! I would like to order a consultation on the RDN.',
          b2bMessengerChoiceTitle: 'Leave a request',
          b2bLeadFormSubmit: 'Submit',
          b2bLeadFormNameLabel: 'Name',
          b2bLeadFormNamePlaceholder: 'Enter your name',
          b2bLeadFormPhoneLabel: 'Phone',
          b2bLeadFormPhonePlaceholder: 'Enter your phone number',
          b2bLeadFormMessengerHint: 'Send the request via messenger — we will call you back.',
          b2bLeadFormPublishHint: 'Publish your request on the Vyriy EMS location marketplace.',
          b2bLeadFormMarketplaceHint: 'Or publish the request without a messenger',
          b2bMessengerPublishMarketplace: 'Publish on Vyriy EMS marketplace',
          b2bMessengerPublishMarketplaceSuccess:
            'Request submitted. It will appear on the marketplace after moderation.',
          b2bMessengerPublishMarketplaceError: 'Failed to publish on the marketplace',
          b2bLeadFormKwLabel: 'Available power, kW',
          b2bLeadFormRequired: 'Required field',
          b2bLeadFormInvalidPhone: 'Enter a valid phone number',
          b2bLeadFormLocationsRequired: 'Add at least one location on the map',
          b2bLeadFormRegionLabel: 'Preferred region',
          b2bLeadFormRegionRequired: 'Select a region on the map',
          b2bLeadFormRegionRadiusLabel: 'Search radius',
          b2bLeadFormRegionRadiusValue: '{{value}} km',
          b2bLeadFormRegionMapHint: 'Click the map to pick a search center, then choose the radius around that point.',
          b2bLeadFormRegionMapAria: 'Map for selecting a region',
          b2bLeadFormMessagePreview: 'Message preview',
          b2bLeadFormSubmitError: 'Fill in all required fields before sending',
          b2bLeadFormSaveError: 'Could not save the request. Please try again.',
          b2bLeadFormSentStatus: 'Your request has been sent. The 220 team will contact you.',
          b2bLeadFormRateLimit: 'Too many requests from this network. Please try later.',
          b2bLeadFormDistributionLabel: 'Oblenergo distribution contract',
          b2bLeadFormYes: 'Yes',
          b2bLeadFormNo: 'No',
          b2bLeadFormLocationsLabel: 'Locations on map',
          b2bLeadFormMapHint:
            'Tap the map to add a location. You can select multiple points. The “My location” button only centers the map.',
          b2bLeadFormMapAria: 'Map for selecting locations',
          b2bLeadFormMapGeolocate: 'My location',
          b2bLeadFormMapLoading: 'Loading…',
          b2bLeadFormMapRemove: 'Remove',
          b2bLeadFormParkingPhotosLabel: 'Parking lot photos (optional)',
          b2bLeadFormConnectionPhotosLabel: 'Connection point photos (optional)',
          b2bMarketplaceMapConnectionPhotos: 'Connection point photos',
          b2bMarketplaceMapParkingPhotos: 'Parking',
          b2bMarketplaceMapKw: 'Power, {{value}} kW',
          b2bLeadFormDistributionContractPhotosLabel: 'Distribution agreement photos (optional)',
          b2bLeadFormDistanceLabel: 'Distance to connection point, m',
          b2bLeadFormDistancePlaceholder: 'Select distance',
          b2bLeadFormDistanceUpTo5: 'Up to 5 m',
          b2bLeadFormPriceKwhExtraLabel: 'Extra price per kWh',
          b2bLeadFormMonthlyParkingLabel: 'Monthly price per parking lot',
          b2bMarketplaceTitle: 'Saved locations',
          b2bMarketplaceSubtitle: 'Published location proposals without contact details',
          b2bMarketplaceMapHint: 'Click a marker on the map to view location details',
          b2bMarketplaceEmpty: 'No published locations yet',
          b2bMarketplaceLoadError: 'Failed to load locations',
          b2bMarketplaceMapAria: 'Map of saved locations',
          b2bMarketplaceDetailTitle: 'Location details',
          b2bMarketplacePublishedOn: 'Published {{timeAgo}}',
          b2bMarketplaceRequestInfo: 'Request information',
          b2bMarketplaceOwnerInfoTitle: 'Location owner contacts',
          b2bMarketplaceOwnerName: 'Name',
          b2bMarketplaceOwnerPhone: 'Phone',
          b2bMarketplaceDistributionContractPhotosLabel: 'Distribution agreement photos',
          b2bMarketplacePayFailed: 'Failed to pay for location information',
          b2bMarketplacePayProcessing: 'Payment is still processing. Try refreshing the page in a minute.',
          b2bMarketplacePayTestSkip: 'Skip payment (local test)',
          b2bMarketplaceViewedTimes: 'Viewed {{count}} times',
          b2bMarketplaceContactTitle: 'Contact about this location',
          b2bMarketplaceContactGreeting: 'Hello! I am interested in a location from the Vyriy EMS marketplace.',
          b2bMarketplaceListingId: 'Listing ID',
          b2bMarketplaceClose: 'Close',
          b2bMarketplaceHeatmapLegendTitle: 'Charging demand',
          b2bMarketplaceHeatmapLegendLow: 'less',
          b2bMarketplaceHeatmapLegendHigh: 'more',
          b2bAccordionLocationMarketplace: 'Location Marketplace',
          b2bMarketplaceShareBtn: 'Share',
          b2bMarketplaceShareCopied: 'Link copied',
          b2bMarketplaceShareText: 'Vyriy EMS location marketplace',
          b2bSectionShareQrAlt: 'QR code for B2B section link',
          b2bSectionShareCopyLink: 'Copy link',
          b2bSectionShareOpenLink: 'Open link',
          b2bAccordionTariffs: 'EV charging station connection tariffs',
          b2bTariffsShareText: '220-km EV charging station connection tariffs',
          b2bAccordionServiceRequest: 'Service Request',
          b2bServiceRequestShareText: '220-km charging station service prices',
          b2bServiceRequestOrderBtn: 'Request service',
          b2bServiceRequestGreeting: 'Hello! I want to request charging station service.',
          b2bAccordionDayAhead: 'Day ahead market + energy storage',
          b2bDayAheadShareText: '220-km day-ahead market + energy storage',
          b2bAccordionCaseBenny: 'Case: roaming showed +18%',
          b2bCaseBennyShareText: '220-km case: roaming showed +18% on the Benny 360 kW charger',
          b2bAccordionCaseBakery: 'Case: bakery, battery through the cycle',
          b2bCaseBakeryShareText: '220-km case: bakery and battery charge',
          b2bAccordionCaseSolar: 'Case: solar, dynamic tariff',
          b2bCaseSolarShareText: '220-km case: solar and dynamic tariff',
          b2bMessengerTelegram: 'Telegram',
          b2bMessengerWhatsApp: 'WhatsApp',
          b2bNewCabinetBtn: 'B2B cabinet Pro (beta)',
          b2bFlowGraphTitle: 'Flow Graph',
          b2bFlowGraphSolar: 'Solar',
          b2bFlowGraphWind: 'Wind',
          b2bFlowGraphWindShareAria: 'Sirocco Energy — QR code and link',
          b2bFlowGraphWindShareTitle: 'Sirocco Energy',
          b2bFlowGraphWindShareSubtitle: 'Scan the QR code or copy the link to the wind turbine documentation',
          b2bFlowGraphWindShareQrAlt: 'QR code for Sirocco Energy link',
          b2bFlowGraphESS: 'ESS',
          b2bFlowGraphEssVendorsTitle: 'Compatible ESS brands',
          b2bFlowGraphEssVendorsAria: 'Show manufacturer logos',
          b2bFlowGraphEssVendorShareCardAria: '{{vendor}} — QR code and link to manufacturer website',
          b2bFlowGraphEssVendorShareTitle: '{{vendor}}',
          b2bFlowGraphEssVendorShareTitleFallback: 'Compatible ESS brands',
          b2bFlowGraphEssVendorShareSubtitle: 'Scan the QR code or copy the link to the manufacturer website',
          b2bFlowGraphEssVendorShareQrAlt: 'QR code for {{vendor}} website link',
          b2bFlowGraphEssVendorOpensExternal: 'manufacturer website, opens in new tab',
          b2bFlowGraphEssCertificateCardAria: '{{vendor}} — official service center authorization certificate',
          b2bFlowGraphEssCertificateModalTitle: 'Certificate of official service center authorization',
          b2bFlowGraphEssCertificateImageAlt: '{{vendor}} official service center authorization certificate',
          b2bFlowGraphInverter: 'Inverter',
          b2bFlowGraphEmsVpp: 'EMS + VPP',
          b2bFlowGraphEmsLinkText: 'EMS',
          b2bFlowGraphEmsVppSuffix: ' + VPP',
          b2bFlowGraphHubOpenEmsAria: '220-km.com — Open EMS power flow, EMS + VPP (opens in new tab)',
          b2bFlowGraphGrid: 'Grid',
          b2bFlowGraphCharging: 'EV Charging',
          b2bFlowGraphMiner: 'Miner',
          b2bFlowGraphMinerShareAria: 'Binance Pool — QR code and link',
          b2bFlowGraphMinerShareTitle: 'Binance Pool',
          b2bFlowGraphMinerShareSubtitle: 'Scan the QR code or copy the link to miner statistics',
          b2bFlowGraphMinerShareQrAlt: 'QR code for Binance Pool link',
          b2bFlowGraphESSCharging: 'Charging',
          b2bFlowGraphESSDischarging: 'Discharging',
          b2bFlowGraphGridSelling: 'Selling',
          b2bFlowGraphExpandWide: 'Expand flow graph (wide screen)',
          b2bFlowGraphCloseWide: 'Back to page',
          b2bFlowGraphUnitKw: 'kW',
          b2bFlowGraphUnitMw: 'MW',
          b2bRevenue: 'Revenue',
          b2bEnergy: 'Energy',
          b2bAverageRate: 'Rate',
          b2bDeposit: 'Deposit',
          b2bTariffs: {
            title: 'EV charging station connection tariffs',
            features: 'Features',
            tariffBase: 'Basic tariff 5%',
            tariffBaseName: 'Basic tariff',
            tariffBaseRate: '5%',
            tariffPro: 'Pro tariff 7%',
            tariffProName: 'Pro tariff',
            tariffProRate: '7%',
            tariffProPlus: 'Pro+ tariff 9%',
            tariffProPlusName: 'Pro+ tariff',
            tariffProPlusEmsLabel: 'integration with',
            tariffProPlusEmsName: 'Vyriy EMS',
            tariffProPlusRate: '9%',
            feature1: 'Business cabinet',
            feature2: 'Shared support Telegram bot',
            feature3: 'Daily payouts to FOP Monobank account',
            feature4: 'Status update every 30 seconds',
            feature15: 'Configure individual and group tariffs',
            feature5: 'Connect budget Chinese stations',
            feature6: 'Free station setup turnkey',
            feature7: 'Free stickers and mobile connection',
            feature8: 'Camera for VIP service for your drivers',
            feature9: 'Dedicated support Telegram group + camera + photo stats',
            feature11: 'Status update every 5 seconds',
            feature12: 'Connect roaming',
            feature13: 'Receive payouts to any Ukrainian bank account',
            feature14: 'Port reservation for drivers',
            feature16: 'Priority service issue resolution',
            feature18: 'Dynamic tariff from battery SoC or DAM (RDN)',
            feature19: 'Vyriy EMS integration',
            feature20: 'Ability to create fuel cards',
          },
          months: {
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September',
            october: 'October',
            november: 'November',
            december: 'December',
          },
          monthsShort: {
            january: 'Jan',
            february: 'Feb',
            march: 'Mar',
            april: 'Apr',
            may: 'May',
            june: 'Jun',
            july: 'Jul',
            august: 'Aug',
            september: 'Sep',
            october: 'Oct',
            november: 'Nov',
            december: 'Dec',
          },
          teslaAdapterNotification: {
            title: 'Guide for american cars with adapter.',
            message: 'If you are using adapter with button, please push it once now!',
            button: 'Got it',
          },
          streetView: {
            title: 'Open 3D View?',
            yes: 'Yes',
            no: 'No',
          },
          map: {
            distanceFromYou: '{{km}} km from you',
            todayStatsTitle: 'Today:',
            todayDriven: 'Driven: {{km}} km',
            todaySpent: 'Spent: {{uah}} uah',
            todayDrivenCompact: '{{km}} km',
            todaySpentCompact: '{{uah}} uah',
            todaySpentPerKm: '{{value}} uah/km',
            speedCameraAhead: 'Speed camera ahead: {{meters}} m',
            speedLimit: 'Speed limit: {{limit}} km/h',
            warningAt: 'Warning at: {{threshold}} km/h',
          },
          locationRequired: {
            title: 'Location access required',
            description:
              'To view the list of stations, please allow access to your location. This will help show the nearest stations.',
            retry: 'Allow location',
            goToMap: 'Go to map',
          },
          freeTestCharge: {
            title: 'Try for free!',
            description: 'We give you your first charge for free to make sure everything works!',
            yesButton: 'Yes, start for free!',
            noButton: 'No, I will pay myself',
          },
          quickStart: {
            button: 'Start',
            headline: 'Welcome on board!',
            intro: 'Connect your car and tap Start.',
            afterSessionHint: 'After you stop the test session, the «Pay» button will appear.',
            description: 'Test that EV charging station works with your EV',
            defaultText: 'Welcome on board!',
          },
          reservation: {
            reserveButton: 'Reserve ({{minutes}} min)',
            btnReserve: 'Reserve',
            btnReserveCooldown: 'Reserve {{time}}',
            reservedByYou: 'Port reserved by you',
            reservedByOther: 'Port reserved by another driver',
            countdown: 'Time left: {{time}}',
            cancel: 'Cancel reservation',
            dailyLimitExceeded: 'Limit: only 1 reservation per day',
            portAlreadyReserved: 'Port is already reserved by another driver',
            notAllowed: 'Reservation is disabled on this port',
            portBusy: 'This port is charging right now, try later',
            postJobCooldown: 'Booking is available 10 minutes after the previous session ends',
            nativeAppRequired: 'Reservation is available only in the 220 app',
            notEligible: 'Reservation is available only in the 220 app',
            webInstallAppPopup: 'To use booking, please install the app',
            webInstallAppBtn: 'Install App',
            failed: 'Could not reserve the port',
            detailsTitle: 'Reservation',
            detailsPort: 'Port #{{port}}',
            detailsDuration: '{{minutes}} min',
            detailsDistance: '{{distance}} km away',
            detailsDistanceUnknown: 'Distance unknown',
            detailsAttemptsLoading: '…',
            detailsAttempts: 'Today reservations: {{used}}/{{max}}',
            detailsConfirm: 'Reserve',
            detailsCancel: 'Cancel',
            tooFar: 'Reservation is only available within {{maxKm}} km of the station',
            locationRequired: 'Enable location on the map to reserve this port',
          },
          restartStation: {
            button: 'Restart station',
            confirmOcpp: 'Restart PORT # {{port}}?\n\n(Device ID copied to clipboard)',
            confirmToka: 'Are you sure you want to reset this TOKA charging station?',
            successOcpp: 'Reset command sent.',
            successToka: 'Station restarted. Command sent.',
            errorFailed: 'Could not restart the station. Please try again later.',
          },
          dcChargingLoader: {
            starting: 'Starting charging',
            title: 'Charging has not started?',
            lead: 'All good, please:',
            steps: 'take the connector out of the car > drive 10 meters > close all doors > and start charging again.',
          },
          freeChargeError: {
            title: 'Error',
            message: 'Too many free charge attempts',
          },
          rateLimitError: {
            title: 'Rate Limit Exceeded',
            message: 'Too many requests. Please try again later.',
          },
          nativeAppFreeChargeError: {
            title: 'Not available in the app',
            message:
              'Free quick start is not available in the mobile app. Top up in the browser at 220-km.com or choose a paid amount below.',
          },
          deployMaintenanceTitle: 'All is ok, we are redeploying.',
          deployMaintenanceWait: 'Please wait ~30 seconds.',
          ...(portNotes.en ? portNotes.en : {}),
        },
      },
    },
  });

export default i18n;
